/**
 * PRIMEX PRICING CONFIGURATOR — assets/primex-configurator.js  (v15.11)
 *
 * ===========================================================================
 * v15.11 — "Bearbeiten": the catalogue motif comes back again.
 *
 *   The live image catalogues have no motif CODE (every radio value is ""),
 *   so _cfg.dsg is empty and edit mode treated the line as "Eigene Datei";
 *   the motif could not be found by its code either. Edit mode now also
 *   passes the motif NAME from the line ("Bildmotiv", or the per-side motif
 *   properties of two-sided products) to primex-textile-cards.js, and a line
 *   with a motif name counts as a catalogue line. Edit mode only — no price,
 *   formula, _cfg content or property changed.
 *
 * ===========================================================================
 * v15.10 — "Bearbeiten" for products WITHOUT a pricing formula (FIXED_MC).
 *
 *   On these products CFG.articleNo is the SKU of the variant the page was
 *   rendered with. When the customer picks the size on the page, the cart
 *   line keeps that first SKU in _cfg.a, while the edit link opens the page
 *   with the chosen variant (other SKU). The "other article" guard then
 *   stopped edit mode silently: no banner, nothing restored.
 *   Now a line also counts as this product when its variant id is one of
 *   this page's variants (CFG.variantTitles). The add-on line is also found
 *   by the article number stored in the line. Edit mode only — no price,
 *   formula, _cfg content or property changed; formula products (no
 *   variantTitles) keep the exact previous check.
 *
 * ===========================================================================
 * v15.9 — "Bearbeiten" from the cart works for round products (FIXED_MC).
 *
 *   Round products never store an Ausführung (their _cfg has exec: null), so
 *   edit mode left "Ohne Stoffbanner" active: the fabric, print choice and
 *   catalogue motif were not restored and the price dropped to frame only.
 *   Edit mode now derives it for round products only (exec empty, diameter
 *   set): a fabric in the line -> "Mit Stoffbanner", else "Ohne Stoffbanner".
 *   Restore only — no formula, no price, no _cfg content, no property name
 *   changed; formula, Handelsware and tagged round products are unaffected.
 *
 * ===========================================================================
 * v15.8 — correction to v15.7: the fabric of a tagged round product IS priced.
 *
 *   The fabric choice stays hidden, but the snippet (v14.34) now passes the
 *   product's linked fabric as CFG.motifFabric. selectedFabric() returns that
 *   real fabric, so the FIXED_MC price adds it exactly as "Mit Stoffbanner"
 *   did before: circle area x fabric price + flat fee, then x CF x CGF x QF.
 *   The cart gets "Textil: <title> (<article no.>)". If the diameter is wider
 *   than the fabric allows, the same "no suitable fabric" message appears as
 *   before. Only when a tagged product has NO fabric linked is nothing added.
 *   Untagged products: unchanged (CFG.motifOnly does not exist there).
 *
 * ===========================================================================
 * v15.7 — Round products (FIXED_MC) can be "motif only", like SILMEA Core.
 *
 *   Opt-in per product: tag  px-motiv-immer  on a ROUND product. The snippet
 *   (primex-configurator.liquid v14.33) then hides "Mit / Ohne Stoffbanner"
 *   and the fabric choice and writes  "motifOnly": true  into the config JSON
 *   (top level — round products have no Formula JSON). This file then:
 *     - treats the textile as always on (textileOnFn);
 *     - uses the same synthetic "fabric" as motifOnly formula products, so
 *       upload / catalogue / print data / Unbedruckt work unchanged;
 *     - adds NO fabric cost (the old circle-area fabric charge + 4,45 flat is
 *       skipped), exactly like computeMCT() does for motifOnly formula products.
 *   Frame colour / RAL, print data and catalogue motif are priced as before.
 *   CFG.motifOnly is ONLY ever present on such a tagged round product, so every
 *   other product (formula, untagged round, Handelsware, Stoffbanner) runs the
 *   identical code path as v15.6.
 *
 * ===========================================================================
 * v15.6 — "Bearbeiten" in the cart restores the configuration and REPLACES
 *         the cart item (Version B).
 *
 *   The cart drawer's Bearbeiten link now carries the cart line key
 *   (?px_edit=<key>, snippets/cart-drawer.liquid v3). On such a page:
 *     1. /cart.js is read and the line is found by its key. Nothing happens
 *        when it is gone, belongs to another product, or carries a price
 *        that is not the configurator's own (a B2B offer at an agreed
 *        price — editing would silently re-price it).
 *     2. The configuration is restored from _cfg and the visible properties:
 *        quantity, B x H (x T), Steuerung, Ausführung, frame colour / RAL,
 *        fabric(s), print data, cable output, Handelsware textile count and
 *        fabrics, the add-on ("Dazu passend"). The variant comes from the
 *        link itself. Artwork choices (Eigene Datei / Katalogmotiv /
 *        Unbedruckt, per card or side) are restored by
 *        primex-textile-cards.js through the 'px:edit-restore' event.
 *     3. Uploaded files are loaded back from their Shopify CDN address into
 *        the same upload field. If that fails, a note with a link to the old
 *        file asks the customer to upload it again.
 *     4. A note at the top says that the item is being edited.
 *   The OLD line stays in the cart until "In den Warenkorb" succeeds. Only
 *   then is it removed (one /cart/update.js call), together with its
 *   add-on line. If Shopify merged the new line into the old one (identical
 *   configuration), the quantity is set instead of removing the line.
 *
 *   NOT changed: no formula, no _calculated_price / _cfg content, no
 *   property name. Normal add to cart (without px_edit) behaves exactly as
 *   before; only in edit mode is the configurator's own /cart/add.js path
 *   used even when there is no file and no add-on, because the old line can
 *   only be removed after a successful add that this file can see.
 *
 * ===========================================================================
 * v15.4 — "Eigene Datei" now REQUIRES a file before add to cart.
 *
 *   Orders arrived with "Mit Stoffbanner" + "Eigene Datei" but no artwork.
 *   On add to cart (native button, Smart Checkout "In den Warenkorb" /
 *   "Sofort kaufen", Enter key) the submit is blocked when a printed textile
 *   is set to "Eigene Datei" and its upload field is empty. The page scrolls
 *   to that upload area and a small red note appears there; it disappears as
 *   soon as a file is chosen or the customer switches to "Katalogmotiv" or
 *   "Unbedruckt/weiß".
 *
 *   Checked per product type:
 *     - normal / Stoffbanner (AREA_FIX) / round products: every upload area of
 *       the product needs a file (motifOnly products with front + back: both);
 *     - dualFabric: each SIDE set to "Eigene Datei" needs its own file;
 *     - Messesystem / Handelsware: each ACTIVE textile card set to
 *       "Eigene Datei" needs its own file.
 *   For the card UIs the core fires 'px:upload-required' ({slot} or {side});
 *   primex-textile-cards.js v1.3 / v1.7 then switches to that card.
 *
 *   Same pattern as the v15.2 add-on rule: a submit-time block, never a
 *   disabled button. No price, no cart property, no _cfg is touched.
 *   NOT checked: "Ohne Stoffbanner", "Katalogmotiv", "Unbedruckt/weiß",
 *   fabrics marked no_print, products without upload fields, and the B2B
 *   quote popup (an offer may still be requested without a file).
 *
 * ===========================================================================
 * v15.3 — Dimensions with ONE decimal (100,5 cm), on every formula product.
 *
 *   Input (#px-width / #px-height / #px-depth):
 *     - becomes a text field with inputmode="decimal" (a type=number field
 *       cannot be limited to one decimal and handles the German comma badly);
 *     - accepts digits and ONE separator, at most ONE digit after it. A second
 *       decimal digit cannot be typed; pasting "100.56" becomes "100.5";
 *     - shows a comma in German and French, a dot in English; either key works;
 *     - the +/- buttons still step 1 cm and keep the decimal (100,5 -> 101,5).
 *
 *   Pricing: the exact value goes into every formula (area, length, perimeter,
 *   fabric fit, min/max limits). Price tiers are written in whole cm
 *   ("bis 250" / "ab 251"), so a decimal that falls between two tiers
 *   (250,5) uses the next tier up — see pickTier().
 *
 *   Cart: "Breite (cm)" / "Höhe (cm)" / "Tiefe (cm)" carry the decimal with a
 *   COMMA in every storefront language ("100,5"), like every other cart value
 *   (PKEY). Whole numbers are written exactly as before ("100"), so existing
 *   products, orders and the Cart Transform see no difference at all. _cfg
 *   keeps numbers (b: 100.5).
 *
 *   NOT changed: no formula, no _calculated_price logic, no property NAME,
 *   round products (diameter comes from the variant), Handelsware/Messesystem.
 *
 * ===========================================================================
 * v15.2 — ONE change. Mandatory add-on selection ("Dazu passend").
 *
 *   Products that render the #px-addons block now REQUIRE one of the add-ons
 *   to be ticked before the product can be added to the cart. The add-ons are
 *   physically necessary parts (e.g. Fußplatten for a freestanding frame), so
 *   an order without one is incomplete — this is what caused the missing
 *   add-on on order PW-1290.
 *
 *   How it works:
 *     - addonRequired()  true when #px-addons exists, holds at least one
 *                        .addon-product-checkbox, and does NOT carry
 *                        data-required="false". Default is REQUIRED, so no
 *                        Liquid change is needed; to exempt a single product
 *                        later, add data-required="false" to #px-addons.
 *     - addonOk()        true when the requirement is met (or not required).
 *     - A red hint is shown inside the add-on block as soon as the block is
 *       visible and nothing is ticked, so the customer sees the rule BEFORE
 *       clicking anything.
 *     - The submit handler hard-blocks the add-to-cart and scrolls the block
 *       into view. This is deliberately a submit-time block and NOT a disabled
 *       button: the Smart Checkout panel buttons (#pxsc-buy-btn / #pxsc-cart-btn
 *       in primex-ui-enhancements.js) work by clicking the real submit button,
 *       and clicking a DISABLED button does nothing at all — the customer would
 *       get a silent dead end with no explanation. Blocking at submit means
 *       every route (native button, Smart Checkout, Enter key) shows the reason.
 *
 *   NOT changed: no pricing formula, no property name, no _cfg key, no add-on
 *   price maths. The add-on was already single-select and already priced via
 *   CF x KRF x QF and added as a second cart line — only the requirement is new.
 *
 *   NOTE: the add-on height ratings (bis 200 cm / bis 250 cm / ab 250 cm) are
 *   NOT enforced. A customer can still choose a set rated below the frame
 *   height. Enforcing that needs a min/max height metafield per add-on product;
 *   parsing it out of the product title would break on any rename.
 *
 * ===========================================================================
 * v15.1 — FIVE changes. No pricing formula is altered. _calculated_price and
 * _cfg keep the exact same shape and values for every scenario, so the Cart
 * Transform function and the B2B quote module receive byte-identical data.
 *
 *  1. form.getAttribute('id') instead of form.id — CORRECTNESS BUG.
 *     HTMLFormElement has [LegacyOverrideBuiltIns]: a control named "id"
 *     SHADOWS the form's own .id property. Because this form contains
 *     <input name="id">, form.id returned that input element (or, while the
 *     duplicate existed, a RadioNodeList) — never the id string. Measured on
 *     the live theme, 13 Oct 2026:
 *         typeof form.id   -> "object"
 *         String(form.id)  -> "[object RadioNodeList]"
 *     So every upload field was given form="[object RadioNodeList]", which
 *     associates it with NO form at all. The manual fd.append() in the submit
 *     handler was quietly rescuing those files; on the native (non-AJAX)
 *     path they were simply lost. The same shadowing made
 *     findProductForm()'s `forms[i].id.includes('installment')` a latent
 *     TypeError, because .includes does not exist on an element.
 *
 *  2. selectedVariantId() now reads the LAST enabled input named "id", and
 *     shouts once in the console if there is more than one.
 *     Shopify resolves a duplicated form field to the LAST value, so this is
 *     the variant that actually reaches the cart; the price must describe
 *     THAT variant. With the duplicate removed from buy-buttons.liquid there
 *     is exactly one input and this behaves identically to before — it is a
 *     guard, so a future duplicate can never again produce the silent
 *     "wrong variant at the right variant's price" cart line.
 *
 *  3. Handelsware lines now write Ausführung (Mit/Ohne Stoffbanner) in BOTH
 *     states. HANDELSWARE_STANDARD and HANDELSWARE_FIXED were the only two
 *     scenarios that never wrote a visible cart property when the customer
 *     chose "Ohne Stoffbanner" — the line reached the cart carrying only
 *     _calculated_price and _cfg, both underscore-prefixed and therefore
 *     hidden, so the drawer had nothing to list and no "Konfiguration
 *     ansehen" toggle. The value comes from hwCount, never from the button's
 *     visible text, so no translation layer can leak into an order.
 *
 *  4. pxClearEmptyState() moved OUT of pxForceOpen(). It had been declared
 *     inside that function, so the call in pxShowCartAfterAdd() threw
 *     ReferenceError, which was swallowed by the fetch .catch() and forced a
 *     full page reload on every add-to-cart that carried an upload or an
 *     add-on.
 *
 *  5. Stoffbanner (AREA_FIX) now shows the customer why the price does not
 *     move below the minimum billable area. Display only: it reports the area
 *     compute() has already calculated, creates its own element so
 *     primex-configurator.liquid is untouched, and is reachable only from the
 *     AREA_FIX branch.
 * ===========================================================================
 *
 *      v15.0: THREE changes, all confined to language handling. No pricing
 *        formula, no _calculated_price, no _cfg and no PXP_quoteSnapshot
 *        behaviour is touched, so the Cart Transform function and the B2B app
 *        receive byte-identical data.
 *          1. DICT gains a full `fr` block, and the language is detected from
 *             <html lang> instead of CFG.locale. <html lang> is set by Shopify
 *             on its own localized URLs AND rewritten by Weglot, so this works
 *             in both worlds — including after Shopify's EN/FR are unpublished
 *             in favour of Weglot, at which point CFG.locale would report "de"
 *             on every URL and the old check would have silently broken EN too.
 *             The detected language is published as window.PX_LANG for
 *             primex-textile-cards.js and primex-ui-enhancements.js, so the
 *             whole configurator has exactly ONE language detector.
 *          2. Cart property NAMES and the values this file generates itself are
 *             now ALWAYS German, in every storefront language — see PKEY below.
 *             Display text translates; what lands on the order does not, so
 *             production, Lexware and the B2B quote module see one naming
 *             scheme forever.
 *          3. Two places used to read a cart property name/value out of VISIBLE
 *             DOM text (hwDynamicFabricPropName, execLabel). Client-side
 *             translation rewrites text nodes, so a French page could put
 *             French into an order. Both now read data-* attributes, which no
 *             translation layer touches.
 * v14.41: the ONLY change from v14.40 is where the response of
 *        /cart/add.js is rendered. No pricing, no cart property, no
 *        _calculated_price, no _cfg and no PXP_quoteSnapshot behaviour is
 *        touched, so the Cart Transform function and the B2B app receive
 *        byte-identical data. See the pxShowCartAfterAdd() block below.
 * v13: + FIX upload click bug (v12 label contained a <button>, which became the label's
 *        implicit target and swallowed clicks) -> new Drag & Drop zone per client design
 *      + NEW Mit Druck / Ohne Druck toggle (client point 2): Ohne Druck hides upload,
 *        catalogue and print data (fabric still priced; unprinted MC pending Wolfgang Q3)
 *      + NEW dual fabric front/back for freestanding products (formula flag "dualFabric")
 *      + catalogue motif selected -> print data hidden AND excluded from price (point 6)
 *      + dimming moved after Textildruck (markup change in liquid, point 7)
 *      + "ralIncluded":true formula flag: RAL selectable at no charge (architect products)
 *      + v13.4: "colorsDisabled":true formula flag (SILMEA/LUMMEA/INTEGRA: predefined
 *        colours, no colour option, no colour cart property); red lines removed;
 *        Dimmung back under the colour selection with bold label
 *      + v13.3: frame colours with use_formula=true (black/white coating) are priced
 *        by the perimeter formula (Umfang x ralRate + ralFlat) like RAL, instead of a
 *        flat surcharge; standard silver stays free; ralIncluded products charge 0
 *      + v13.2: the cable diagram is DRAWN AS AN INLINE SVG (frame, numbered circles,
 *        plug icon) — responsive on every device, numbers are real elements: hover
 *        shows a red ring, click selects and syncs the dropdown. Uses hotspot
 *        percentages from CFG.cableHotspots; without them the metaobject image +
 *        zoom popup is shown as before.
 *      + kept from v12: tooltips (option_tooltips), taxesIncluded net/gross switch,
 *        FormData submit takeover for files, drawer ALWAYS opens after add to cart
 *      + v14.7: mc_cents can ALSO be entered directly in EUROS via a new optional
 *        variant metafield custom.mc_euros — for new round products, no x100 math
 *        needed. If present it wins; existing integer-cents products are untouched.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('px-config');
  var root = document.getElementById('px-configurator');
  if (!cfgEl || !root) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.error('PX: bad config JSON', e); return; }

  // ---------------- i18n ----------------
  var DICT = {
    de: {
      dims: 'Breite × Höhe in cm',
      dims3: 'Breite × Höhe × Tiefe in cm',
      depth: 'Tiefe',
      uploadLabel: 'Eigene Bilddatei hochladen',
      uploadMax: '(max. 20 MB)',
      dropText: 'Drag & Drop Ihrer Dateien oder',
      browse: 'Datei auswählen',
      uploadHint: 'Erlaubt: JPG, PNG, PDF, AI, EPS.',
      sideFront: '(Vorderseite)',
      sideBack: '(Rückseite)',
      addonTitle: 'Dazu passend:',
      // v15.2 — shown when the add-on block is visible and nothing is ticked.
      addonRequired: 'Bitte wählen Sie eines der folgenden Zubehörteile – für dieses Produkt ist die Auswahl erforderlich.',
      // v15.4 — shown in the upload area when "Eigene Datei" has no file.
      uploadRequired: 'Bitte laden Sie Ihre Bilddatei hoch – oder wählen Sie „Katalogmotiv“ bzw. „Unbedruckt/weiß“.',
      // v15.6 — editing a cart item.
      editBanner: 'Sie bearbeiten einen Artikel aus Ihrem Warenkorb. Mit „In den Warenkorb“ wird er durch die neue Konfiguration ersetzt.',
      editCancel: 'Abbrechen – Artikel unverändert lassen',
      editFileFailed: 'Ihre bisherige Datei konnte nicht automatisch übernommen werden. Bitte laden Sie sie erneut hoch:',
      adNet: 'netto',
      adGross: 'inkl. 19% MwSt.',
      pAddonFor: 'Zubehör für',
      frameColor: 'Rahmenfarbe:',
      ralOption: 'Individuelle RAL-Farbe',
      ralPlaceholder: 'RAL-Farbton, z. B. RAL 3020',
      execution: 'Ausführung',
      withT: 'Mit Stoffbanner',
      withoutT: 'Ohne Stoffbanner',
      printWith: 'Mit Druck',
      printWithout: 'Ohne Druck',
      dimming: 'Mit Dimmung',
      cableLabel: 'Auswahl über Bild',
      infoModalTitle: 'Information',
      textilePrinting: 'Stoffbanner',
      textileType: 'Auswahl Textilart',
      textileTypeFront: 'Auswahl Textilart Vorderseite',
      textileTypeBack: 'Auswahl Textilart Rückseite',
      catalogToggle: 'Katalogmotiv wählen',
      printData: 'Druckdatenverarbeitung',
      netUnit: 'netto / Stück',
      vatNote: function (r) { return 'inkl. ' + Math.round(r * 100) + '% MwSt.'; },
      quoteNote: function (n) { return 'Ab einer Menge von mehr als ' + n + ' Stück erstellen wir Ihnen gerne ein individuelles Angebot. Bitte kontaktieren Sie uns.'; },
      errRange: function (f, min, max) { return f + ' muss zwischen ' + min + ' und ' + max + ' cm liegen.'; },
      errNoFabric: 'Für diese Abmessungen ist keine passende Textilart verfügbar.',
      width: 'Breite', height: 'Höhe', enter: 'Bitte Maße eingeben.',
      lineTotal: function (q, s) { return q + ' × = ' + s + ' brutto'; },
      // v15.1 — Stoffbanner minimum-area hint. DISPLAY ONLY, never a cart value.
      areaNote: function (b, h, a) { return 'Fläche: ' + b + ' × ' + h + ' cm = ' + a + ' m²'; },
      areaMin: function (m) { return '→ berechnet mit der Mindestfläche ' + m + ' m²'; },
      pW: 'Breite (cm)', pH: 'Höhe (cm)', pT: 'Tiefe (cm)', pDim: 'Dimmung', pFab: 'Textil',
      pDia: 'Durchmesser (cm)',
      pFabF: 'Textil Vorderseite', pFabB: 'Textil Rückseite', pPrint: 'Druck',
      pCol: 'Rahmenfarbe', pRal: 'RAL-Farbe', pExec: 'Ausführung', pPd: 'Druckdatenverarbeitung',
      pCab: 'Kabelausgang', pDsg: 'Bildmotiv',
      yes: 'Ja', pos: function (n) { return 'Position ' + n; },
      priceOnRequest: 'Preis auf Anfrage – bitte kontaktieren Sie uns.',
      addError: 'Fehler beim Hinzufügen zum Warenkorb.',
      fmtLocale: 'de-DE'
    },
    en: {
      dims: 'Individual dimensions in cm (W x H)',
      dims3: 'Individual dimensions in cm (W x H x D)',
      depth: 'Depth',
      uploadLabel: 'Upload your own image file',
      uploadMax: '(max. 20 MB)',
      dropText: 'Drag & drop your files or',
      browse: 'Select file',
      uploadHint: 'Allowed: JPG, PNG, PDF, AI, EPS.',
      sideFront: '(front side)',
      sideBack: '(back side)',
      addonTitle: 'Matching add-ons:',
      // v15.2 — shown when the add-on block is visible and nothing is ticked.
      addonRequired: 'Please select one of the add-ons below — a selection is required for this product.',
      uploadRequired: 'Please upload your image file – or choose “Catalogue motif” or “Unprinted/white”.',
      editBanner: 'You are editing an item from your cart. “Add to cart” replaces it with the new configuration.',
      editCancel: 'Cancel – keep the item unchanged',
      editFileFailed: 'Your previous file could not be taken over automatically. Please upload it again:',
      adNet: 'net',
      adGross: 'incl. 19% VAT',
      pAddonFor: 'Accessory for',
      frameColor: 'Frame color:',
      ralOption: 'Individual RAL COLOUR',
      ralPlaceholder: 'RAL code, e.g. RAL 3020',
      execution: 'Execution',
      withT: 'With Textile',
      withoutT: 'Without textile (frame only)',
      printWith: 'With printing',
      printWithout: 'Without printing',
      dimming: 'With dimming',
      cableLabel: 'Select from image',
      infoModalTitle: 'Information',
      textilePrinting: 'Textile printing',
      textileType: 'Selection Textile type',
      textileTypeFront: 'Textile type front',
      textileTypeBack: 'Textile type back',
      catalogToggle: 'Select a specified subject from our image catalogue',
      printData: 'Print data processing',
      netUnit: 'net / unit',
      vatNote: function (r) { return 'incl. ' + Math.round(r * 100) + '% VAT'; },
      quoteNote: function (n) { return 'For quantities above ' + n + ' we prepare an individual quotation. Please contact us.'; },
      errRange: function (f, min, max) { return f + ' must be between ' + min + ' and ' + max + ' cm.'; },
      errNoFabric: 'No available fabric is suitable for these dimensions.',
      width: 'Width', height: 'Height', enter: 'Please enter dimensions.',
      lineTotal: function (q, s) { return q + ' × = ' + s + ' gross'; },
      areaNote: function (b, h, a) { return 'Area: ' + b + ' × ' + h + ' cm = ' + a + ' m²'; },
      areaMin: function (m) { return '→ billed as the minimum area of ' + m + ' m²'; },
      pW: 'Width (cm)', pH: 'Height (cm)', pT: 'Depth (cm)', pDim: 'Dimming', pFab: 'Fabric',
      pDia: 'Diameter (cm)',
      pFabF: 'Fabric front', pFabB: 'Fabric back', pPrint: 'Printing',
      pCol: 'Frame colour', pRal: 'RAL colour', pExec: 'Execution', pPd: 'Print data processing',
      pCab: 'Cable output', pDsg: 'Image catalogue subject',
      yes: 'Yes', pos: function (n) { return 'Position ' + n; },
      priceOnRequest: 'Price on request – please contact us.',
      addError: 'Error adding to cart.',
      fmtLocale: 'en-GB'
    },
    // v15.0 — French.
    // NOTE: this block deliberately contains NO p* cart-property keys. Cart
    // property names and generated values are always German (see PKEY below);
    // only what the customer reads on screen is translated here.
    // `yes` and `pos` ARE present because pos() is also used as an SVG
    // aria-label, which must be translated.
    fr: {
      dims: 'Largeur × Hauteur en cm',
      dims3: 'Largeur × Hauteur × Profondeur en cm',
      depth: 'Profondeur',
      uploadLabel: 'Télécharger votre propre fichier image',
      uploadMax: '(max. 20 Mo)',
      dropText: 'Glissez-déposez vos fichiers ou',
      browse: 'Choisir un fichier',
      uploadHint: 'Formats autorisés : JPG, PNG, PDF, AI, EPS.',
      sideFront: '(recto)',
      sideBack: '(verso)',
      addonTitle: 'Accessoires assortis :',
      // v15.2 — shown when the add-on block is visible and nothing is ticked.
      addonRequired: 'Veuillez sélectionner l\'un des accessoires ci-dessous — une sélection est obligatoire pour ce produit.',
      uploadRequired: 'Veuillez télécharger votre fichier image – ou choisir « Motif du catalogue » ou « Non imprimé / blanc ».',
      editBanner: 'Vous modifiez un article de votre panier. « Ajouter au panier » le remplace par la nouvelle configuration.',
      editCancel: 'Annuler – conserver l\'article tel quel',
      editFileFailed: 'Votre fichier précédent n\'a pas pu être repris automatiquement. Veuillez le télécharger à nouveau :',
      adNet: 'HT',
      adGross: 'TVA 19 % incluse',
      pAddonFor: 'Accessoire pour',
      frameColor: 'Couleur du cadre :',
      ralOption: 'Couleur RAL personnalisée',
      ralPlaceholder: 'Teinte RAL, p. ex. RAL 3020',
      execution: 'Version',
      withT: 'Avec bannière textile',
      withoutT: 'Sans bannière textile',
      printWith: 'Avec impression',
      printWithout: 'Sans impression',
      dimming: 'Avec variateur',
      cableLabel: 'Sélection sur l\'image',
      infoModalTitle: 'Information',
      textilePrinting: 'Bannière textile',
      textileType: 'Choix du type de textile',
      textileTypeFront: 'Choix du type de textile — recto',
      textileTypeBack: 'Choix du type de textile — verso',
      catalogToggle: 'Choisir un motif du catalogue',
      printData: 'Traitement des données d\'impression',
      netUnit: 'HT / pièce',
      vatNote: function (r) { return 'TVA ' + Math.round(r * 100) + ' % incluse'; },
      quoteNote: function (n) { return 'À partir de ' + n + ' pièces, nous établissons volontiers un devis personnalisé. Merci de nous contacter.'; },
      errRange: function (f, min, max) { return f + ' doit être compris entre ' + min + ' et ' + max + ' cm.'; },
      errNoFabric: 'Aucun textile disponible ne convient à ces dimensions.',
      width: 'Largeur', height: 'Hauteur', enter: 'Veuillez saisir les dimensions.',
      lineTotal: function (q, s) { return q + ' × = ' + s + ' TTC'; },
      areaNote: function (b, h, a) { return 'Surface : ' + b + ' × ' + h + ' cm = ' + a + ' m²'; },
      areaMin: function (m) { return '→ facturé sur la surface minimale de ' + m + ' m²'; },
      yes: 'Oui', pos: function (n) { return 'Position ' + n; },
      priceOnRequest: 'Prix sur demande – merci de nous contacter.',
      addError: 'Erreur lors de l\'ajout au panier.',
      fmtLocale: 'fr-FR'
    }
  };

  // v15.0: the language is read from the DOCUMENT, not from CFG.locale.
  //
  // <html lang="..."> is set by Shopify on its own localized URLs AND is
  // rewritten by Weglot when it switches language, so reading it works in both
  // worlds. This matters: once Shopify's EN/FR are unpublished in favour of
  // Weglot, request.locale — and therefore CFG.locale — reports "de" on every
  // URL, and the old `CFG.locale === 'en'` check would have silently broken the
  // English configurator as well as never supporting French.
  //
  // CFG.locale is kept as a fallback for the case where <html lang> is missing.
  // Detection ORDER matters. The URL prefix is present in the very first byte
  // of the document, whereas Weglot rewrites <html lang> only once its own
  // script has run — which can be AFTER a deferred script like this one. Taking
  // the URL first removes that race, so the configurator can never render in
  // one language while the rest of the page shows another.
  function pxDetectLang() {
    var p = (location.pathname || '/').toLowerCase();
    if (p === '/en' || p.indexOf('/en/') === 0) return 'en';
    if (p === '/fr' || p.indexOf('/fr/') === 0) return 'fr';
    if (p === '/de' || p.indexOf('/de/') === 0) return 'de';
    var raw = (document.documentElement.getAttribute('lang') || '').toLowerCase().split('-')[0];
    if (raw === 'en' || raw === 'fr' || raw === 'de') return raw;
    return (CFG.locale === 'en') ? 'en' : 'de';
  }
  var lang = pxDetectLang();

  // Published for primex-textile-cards.js and primex-ui-enhancements.js, which
  // both load AFTER this file. ONE detector for the whole configurator — three
  // independent ones is exactly what broke French in the first place.
  window.PX_LANG = lang;

  var L = DICT[lang];

  // ------------------------------------------------------------------
  // PKEY — CART PROPERTY NAMES AND GENERATED VALUES. ALWAYS GERMAN.
  //
  // Display text is translated; what lands on the order is not. Production,
  // Lexware and the B2B quote module therefore see exactly one naming scheme
  // in every storefront language.
  //
  // DICT.de already holds every one of these (pW, pH, pT, pDia, pDim, pExec,
  // pFab, pFabF, pFabB, pPrint, pPd, pCab, pDsg, pCol, pRal, pAddonFor, plus
  // the generated values yes / printWith / printWithout / withT / withoutT /
  // pos), so this alias IS the frozen table — there is nothing to keep in sync
  // and no second list to forget to update.
  //
  // IMPORTANT: ALL_PROP_KEYS below is deliberately NOT changed. It must keep
  // sweeping the German AND English key names so hidden inputs left behind by
  // pre-v15.0 English sessions are still cleared. No French property keys ever
  // existed, so there is nothing French to sweep.
  // ------------------------------------------------------------------
  var PKEY = DICT.de;

  var fmt = new Intl.NumberFormat(L.fmtLocale, { style: 'currency', currency: 'EUR' });

  // ---------- fabric tooltips from custom.option_tooltips (normalized match) ----------
  var TIPMAP = {};
  var tipNorm = null;
  (function () {
    var src = CFG.optionTooltips || null;
    if (!src || typeof src !== 'object') return;
    tipNorm = function (s) { return String(s).toLowerCase().replace(/[^a-z0-9äöüß]/g, ''); };
    Object.keys(src).forEach(function (k) { TIPMAP[tipNorm(k)] = src[k]; });
  })();
  function tooltipFor(title) {
    if (!tipNorm || !title) return null;
    return TIPMAP[tipNorm(title)] || null;
  }

  // All cart property names in BOTH languages (to clear stale ones on switch)
  var ALL_PROP_KEYS = [];
  ['de', 'en'].forEach(function (lg) {
    ['pW', 'pH', 'pT', 'pDia', 'pDim', 'pExec', 'pFab', 'pFabF', 'pFabB', 'pPrint', 'pPd', 'pCab', 'pDsg', 'pCol', 'pRal'].forEach(function (k) {
      if (ALL_PROP_KEYS.indexOf(DICT[lg][k]) === -1) ALL_PROP_KEYS.push(DICT[lg][k]);
    });
    for (var hwPropIndex = 1; hwPropIndex <= 6; hwPropIndex++) {
      var fabricKey = DICT[lg].pFab + ' ' + hwPropIndex;
      var designKey = (lg === 'en' ? 'Design textile banner ' : 'Gestaltung Stoffbanner ') + hwPropIndex;
      var motifKey = (lg === 'en' ? 'Catalogue motif textile banner ' : 'Katalogmotiv Stoffbanner ') + hwPropIndex;
      [fabricKey, designKey, motifKey].forEach(function (key) {
        if (ALL_PROP_KEYS.indexOf(key) === -1) ALL_PROP_KEYS.push(key);
      });
    }
  });

  // ---------- elements ----------
  var $w = document.getElementById('px-width');
  var $h = document.getElementById('px-height');
  var $t = document.getElementById('px-depth'); // only exists for BHT products

  /* ---------- v15.3: dimensions with ONE decimal ----------
     readDim()        input -> number with one decimal (NaN when empty/invalid).
                      Accepts "100,5" and "100.5".
     fmtDimDisplay()  number -> what the CUSTOMER sees: comma (de/fr), dot (en).
     fmtDimCart()     number -> what lands on the ORDER: always comma, like every
                      other cart value (PKEY). Whole numbers stay "100". */
  var DIM_INPUTS = [$w, $h, $t].filter(Boolean);
  function dimSep() { return lang === 'en' ? '.' : ','; }
  function round1(n) { return Math.round(n * 10) / 10; }
  function readDim(el) {
    if (!el) return NaN;
    var s = String(el.value == null ? '' : el.value).trim().replace(',', '.');
    if (!s || s === '.') return NaN;
    var n = parseFloat(s);
    return isFinite(n) ? round1(n) : NaN;
  }
  function fmtDimDisplay(n) {
    var r = round1(n);
    return Number.isInteger(r) ? String(r) : String(r).replace('.', dimSep());
  }
  function fmtDimCart(n) {
    var r = round1(n);
    return Number.isInteger(r) ? String(r) : String(r).replace('.', ',');
  }
  // Keeps digits and ONE separator with at most ONE digit after it.
  function sanitizeDimText(raw) {
    var s = String(raw == null ? '' : raw).replace(/[^0-9.,]/g, '');
    var i = s.search(/[.,]/);
    if (i === -1) return s.slice(0, 5);
    var whole = s.slice(0, i).slice(0, 5);
    var dec = s.slice(i + 1).replace(/[.,]/g, '').slice(0, 1);
    return whole + dimSep() + dec;
  }
  function normalizeDimInput(el) {
    var n = readDim(el);
    if (isFinite(n) && n > 0) el.value = fmtDimDisplay(n);
  }
  DIM_INPUTS.forEach(function (el) {
    // type=number cannot be held to one decimal and rejects the German comma
    // in some browsers, so the field becomes text with a decimal keypad.
    // min/max stay as attributes; the stepper and validate() read them.
    try { el.type = 'text'; } catch (e) { /* very old browsers: stays number */ }
    el.setAttribute('inputmode', 'decimal');
    el.setAttribute('autocomplete', 'off');
    normalizeDimInput(el);
    el.addEventListener('input', function () {
      var before = el.value;
      var clean = sanitizeDimText(before);
      if (clean === before) return;
      var caret = el.selectionStart;
      el.value = clean;
      if (caret !== null && caret !== undefined) {
        var pos = Math.min(clean.length, sanitizeDimText(before.slice(0, caret)).length);
        try { el.setSelectionRange(pos, pos); } catch (e) { /* no-op */ }
      }
    });
    // "100," -> "100", "100,0" -> "100" once the customer leaves the field.
    el.addEventListener('blur', function () { normalizeDimInput(el); });
  });
  var $err = document.getElementById('px-dim-error');
  function setErr(msg) { if ($err) $err.textContent = msg; }
  var $dimWrap = document.getElementById('px-dimming-wrap');
  var $dim = document.getElementById('px-dimming');
  var $ralWrap = document.getElementById('px-ral-code-wrap');
  var $ralCode = document.getElementById('px-ral-code');
  var $colorName = document.getElementById('px-color-name');
  var $execBtns = root.querySelectorAll('.px-exec-btn');
  var $printBtns = root.querySelectorAll('.px-print-btn');
  var $printRow = document.getElementById('px-print');
  var $textileSection = document.getElementById('px-textile-section');
  var $fabricSelect = document.getElementById('px-fabric-select');
  var $fabricSelect2 = document.getElementById('px-fabric-select2'); // dualFabric products only
  var $fabricInfo = document.getElementById('px-fabric-info');
  var $pdWrap = document.getElementById('px-pd-wrap');
  var $pfUpWraps = Array.prototype.slice.call(root.querySelectorAll('.px-upload-wrap'));
  var $pdSelect = document.getElementById('px-pd-select');
  var $designWrap = document.getElementById('px-design-wrap');
  var $designToggle = document.getElementById('px-design-toggle');
  var $designArea = document.getElementById('px-design-area');
  var $designCatalog = document.getElementById('px-design-catalog');
  var $cableSelect = document.getElementById('px-cable-select');
  var $cableDiagram = document.getElementById('px-cable-diagram');
  var $price = document.getElementById('px-price');
  var $net = document.getElementById('px-price-net');
  var $gross = document.getElementById('px-price-gross');
  var $line = document.getElementById('px-line-total');
  var $totalNet = document.getElementById('px-total-net');
  var $totalGross = document.getElementById('px-total-gross');
  var $vatNote = document.getElementById('px-vat-note');
  var $quote = document.getElementById('px-quote-note');
  var $lightbox = document.getElementById('px-lightbox');
  var $lightboxImg = document.getElementById('px-lightbox-img');
  var $lightboxClose = document.getElementById('px-lightbox-close');
  var $lightboxHotspots = document.getElementById('px-lightbox-hotspots');
  // v14.4: shared fabric-info popup (one modal, filled per icon clicked)
  var $infoModal = document.getElementById('px-info-modal');
  var $infoModalBody = document.getElementById('px-info-modal-body');
  var $infoModalClose = document.getElementById('px-info-modal-close');
  var $infoModalTitle = document.getElementById('px-info-modal-title');
  var $cableSvgWrap = document.getElementById('px-cable-svg');
  // v14.0: Handelsware textile add-on
  var $hwWrap = document.getElementById('px-hw-textile');
  var $hwModeBtns = $hwWrap ? $hwWrap.querySelectorAll('#px-hw-modes .px-exec-btn') : [];
  var $hwPd = document.getElementById('px-hw-pd');
  var $hwPdSelect = document.getElementById('px-hw-pd-select');
  var hwCount = 0; // 0 = Ohne Textil
  // v14.2: add-on products ("Dazu passend")
  var $addons = document.getElementById('px-addons');
  function selectedAddonBox() {
    if (!$addons) return null;
    var boxes = $addons.querySelectorAll('.addon-product-checkbox:checked');
    return boxes.length ? boxes[boxes.length - 1] : null;
  }
  function addonSelection() {
    var box = selectedAddonBox();
    if (!box) return null;
    var item = box.closest('.addon-product-item');
    var sel = item ? item.querySelector('.px-addon-variant') : null;
    var vid = box.dataset.variantId;
    var base = parseInt(box.dataset.price, 10) || 0;
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (opt) { vid = opt.value; base = parseInt(opt.dataset.variantPrice, 10) || base; }
    }
    return { variantId: vid, baseCents: base, title: box.dataset.title || '' };
  }
  // add-ons (feet etc.) are Handelsware-Standard products: base x CF x KRF x QF
  function addonUnitNetCents(qty) {
    var ad = addonSelection();
    if (!ad || !ad.baseCents) return 0;
    var qf = qtyFactor(qty);
    if (qf === null) qf = 0.97; // above threshold the MAIN product already blocks checkout
    var krf = (CFG.factors && CFG.factors.krf) ? CFG.factors.krf : 1.0;
    return Math.round(ad.baseCents * CFG.factors.cf * krf * qf);
  }
  /* ------------------------------------------------------------------
     v15.2 — MANDATORY add-on selection.

     The add-ons in #px-addons are physically necessary parts (Fußplatten
     for a freestanding frame, etc.), not optional extras. A product that
     renders the block may not be added to the cart until one of them is
     ticked.

     Default is REQUIRED, so nothing has to change in
     snippets/primex-configurator.liquid. To exempt a single product later,
     put data-required="false" on the #px-addons element in that Liquid:

         <div class="adon-product-cst" id="px-addons" data-required="false" ...>

     Everything below is gating only. No price, no property, no _cfg key is
     touched by any of it.
  ------------------------------------------------------------------ */
  function addonBoxes() {
    return $addons ? $addons.querySelectorAll('.addon-product-checkbox') : [];
  }
  function addonRequired() {
    if (!$addons) return false;
    if ($addons.getAttribute('data-required') === 'false') return false;
    return addonBoxes().length > 0;
  }
  function addonOk() {
    if (!addonRequired()) return true;
    return !!selectedAddonBox();
  }
  // Lazily created hint line, appended to the end of #px-addons. Styles are
  // inline on purpose: this needs no change to any .css asset.
  function addonNoteEl() {
    if (!$addons) return null;
    var el = $addons.querySelector('.px-addon-req');
    if (!el) {
      el = document.createElement('div');
      el.className = 'px-addon-req';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'display:none;margin-top:10px;padding:8px 10px;' +
        'font-size:12.5px;line-height:1.45;color:#b3261e;' +
        'background:#fdf3f2;border:1px solid #f3cfcb;';
      $addons.appendChild(el);
    }
    return el;
  }
  function refreshAddonNote() {
    var el = addonNoteEl();
    if (!el) return;
    if (addonRequired() && !selectedAddonBox()) {
      el.textContent = L.addonRequired;
      el.style.display = 'block';
    } else {
      el.style.display = 'none';
    }
  }
  // Called when the customer tries to submit without a selection.
  function flagAddonMissing() {
    refreshAddonNote();
    if (!$addons) return;
    $addons.style.display = 'block';
    try { $addons.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    var first = addonBoxes()[0];
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
  }
  function showAddons(on) {
    if (!$addons) return;
    $addons.style.display = on ? 'block' : 'none';
    // v15.2: the hint has to track every recompute, because compute() is what
    // runs after a checkbox change (the change handler calls schedule()).
    if (on) refreshAddonNote();
  }
  function refreshAddonTiles() {
    if (!$addons) return;
    var qty = getQty();
    var qf = qtyFactor(qty); if (qf === null) qf = 0.97;
    var krf = (CFG.factors && CFG.factors.krf) ? CFG.factors.krf : 1.0;
    $addons.querySelectorAll('.addon-product-item').forEach(function (item) {
      var box = item.querySelector('.addon-product-checkbox');
      var sel = item.querySelector('.px-addon-variant');
      var base = parseInt(box.dataset.price, 10) || 0;
      if (sel) {
        var opt = sel.options[sel.selectedIndex];
        if (opt) base = parseInt(opt.dataset.variantPrice, 10) || base;
      }
      var net = Math.round(base * CFG.factors.cf * krf * qf);
      var gross = Math.round(net * (1 + CFG.settings.vat));
      var nEl = item.querySelector('.px-ad-net');
      var gEl = item.querySelector('.px-ad-gross');
      if (nEl) nEl.textContent = fmt.format(net / 100);
      if (gEl) gEl.textContent = fmt.format(gross / 100);
    });
  }
  if ($addons) {
    $addons.querySelectorAll('.addon-product-checkbox').forEach(function (box) {
      box.addEventListener('change', function () {
        if (box.checked) { // single-select: uncheck the others
          $addons.querySelectorAll('.addon-product-checkbox').forEach(function (b) {
            if (b !== box) b.checked = false;
          });
        }
        refreshAddonNote(); // v15.2: immediate, not after the compute debounce
        schedule();
      });
    });
    $addons.querySelectorAll('.px-addon-variant').forEach(function (sel) {
      sel.addEventListener('change', function () {
        // interacting with an add-on's variant means the customer wants THIS add-on:
        // select it and enforce single-select strictly
        var item = sel.closest('.addon-product-item');
        var box = item ? item.querySelector('.addon-product-checkbox') : null;
        if (box) {
          box.checked = true;
          $addons.querySelectorAll('.addon-product-checkbox').forEach(function (b) {
            if (b !== box) b.checked = false;
          });
        }
        refreshAddonTiles();
        schedule();
      });
      // clicking the select must not toggle the surrounding label's checkbox
      sel.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    refreshAddonTiles();
  }

  // Move lightbox to <body>: theme sections use CSS transforms which trap position:fixed
  if ($lightbox && $lightbox.parentElement !== document.body) {
    document.body.appendChild($lightbox);
  }

  // execution mode: 'NONE' = frame only; 'WITH' = single-fabric products;
  // or a fabricModes code like 'F5'/'T2' for panel-based products
  var execMode = (function () {
    var active = root.querySelector('.px-exec-btn.px-active');
    return active ? active.dataset.mode : 'WITH';
  })();
  // v13: printing mode — 'YES' (default) or 'NO' (Ohne Druck, client point 2)
  var printMode = 'YES';

  function textileOnFn() {
    if (CFG.formula && CFG.formula.kind === 'AREA_FIX') return true; // v14.9: Stoffbanner — always "on", no frame/fabric toggle
    if (CFG.formula && CFG.formula.motifOnly) return true; // v14.11: freestanding acoustic panels — motif upload always available, no fabric-type choice
    if (CFG.motifOnly === true) return true; // v15.7: round product with tag px-motiv-immer (no Formula JSON)
    if (!$fabricSelect) return false; // acoustic/architect products: no textile at all
    return execMode !== 'NONE';
  }
  function printedFn(fab) {
    return textileOnFn() && printMode === 'YES' && fab && !fab.noPrint;
  }
  function activeFabricMode() {
    var modes = CFG.formula ? CFG.formula.fabricModes : null;
    if (!modes) return null;
    for (var i = 0; i < modes.length; i++) if (modes[i].code === execMode) return modes[i];
    return null;
  }

  if (CFG.formula && CFG.formula.dimmingAvailable && $dimWrap) $dimWrap.style.display = 'flex';

  // ---------- language application ----------
  function hwLocalizeModeButtons() {
    var wrap = document.getElementById('px-hw-modes');
    if (!wrap) return;
    wrap.querySelectorAll('.px-exec-btn').forEach(function (b) {
      var n = parseInt(b.dataset.count, 10) || 0;
      if (n > 0) {
        b.textContent = (lang === 'en')
          ? ('With ' + n + ' textile' + (n > 1 ? 's' : ''))
          : (lang === 'fr')
            ? ('Avec ' + n + ' textile' + (n > 1 ? 's' : ''))
            : ('Mit ' + n + ' Textil' + (n > 1 ? 'ien' : ''));
      }
    });
  }
  function applyLang() {
    hwLocalizeModeButtons();
    L = DICT[lang];
    // v15.3: the decimal separator follows the language (comma de/fr, dot en).
    DIM_INPUTS.forEach(normalizeDimInput);
    fmt = new Intl.NumberFormat(L.fmtLocale, { style: 'currency', currency: 'EUR' });

    root.querySelectorAll('[data-i18n]').forEach(function (el) {
      var key = el.dataset.i18n;
      if (typeof L[key] === 'string') el.textContent = L[key];
    });
    root.querySelectorAll('[data-i18n-placeholder]').forEach(function (el) {
      var key = el.dataset.i18nPlaceholder;
      if (typeof L[key] === 'string') el.placeholder = L[key];
    });

    [$pdSelect, $hwPdSelect].forEach(function (sel) {
      if (!sel) return;
      for (var pi = 0; pi < sel.options.length; pi++) {
        var po = sel.options[pi];
        var pmc = parseFloat(po.dataset.mc || '0') || 0;
        po.text = (po.dataset.name || po.text) + (pmc > 0 ? ' (+ ' + fmt.format(pmc) + ')' : '');
      }
    });

    root.querySelectorAll('.px-dtip').forEach(function (el) {
      var p = parseFloat(el.dataset.price || '0') || 0;
      el.textContent = (el.dataset.name || '') + (p > 0 ? ' (+ ' + fmt.format(p) + ')' : '');
    });

    compute();
  }

  // ---------- product form (Dawn-safe finder) ----------
  // v15.1: NEVER read `.id` from a form that contains a control named "id" —
  // HTMLFormElement's named getter shadows the property and returns the input
  // itself. Use getAttribute('id') everywhere. The old
  // `(forms[i].id || '').includes(...)` was a latent TypeError for exactly
  // this reason, because .includes does not exist on an element.
  function formIdOf(f) {
    return (f && f.getAttribute) ? (f.getAttribute('id') || '') : '';
  }
  function findProductForm() {
    var section = root.closest('.shopify-section') || document;
    var f = section.querySelector('form[data-type="add-to-cart-form"]');
    if (f) return f;
    f = document.querySelector('form[data-type="add-to-cart-form"]');
    if (f) return f;
    f = document.querySelector('product-form form[action*="/cart/add"]');
    if (f) return f;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('[name="id"]') && formIdOf(forms[i]).indexOf('installment') === -1) return forms[i];
    }
    return forms[0] || null;
  }
  var form = findProductForm();
  if (form && root.querySelector('.px-upinput')) {
    form.setAttribute('enctype', 'multipart/form-data');
    // file inputs sit OUTSIDE the form (Custom Liquid block): associate via form attribute
    if (!formIdOf(form)) form.setAttribute('id', 'px-product-form');
    var pxFormId = formIdOf(form);
    root.querySelectorAll('.px-upinput').forEach(function (inp) {
      inp.setAttribute('form', pxFormId);
    });
  }
  var submitBtn = form ? (form.querySelector('[type="submit"]') || form.querySelector('button[name="add"]')) : null;

  function getQty() {
    var q = 1;
    var el = form ? form.querySelector('[name="quantity"]') : null;
    if (!el) el = document.querySelector('[name="quantity"]');
    if (el) q = parseInt(el.value, 10) || 1;
    return q;
  }

  // Quantity totals are calculated here in the pricing engine for EVERY product
  // category. Smart Checkout only mirrors these already-formatted values.
  function writeDisplayedTotals(unitNetCents, unitGrossCents, qty) {
    if ($totalNet) $totalNet.textContent = fmt.format((unitNetCents * qty) / 100);
    if ($totalGross) $totalGross.textContent = fmt.format((unitGrossCents * qty) / 100);
  }
  function clearDisplayedTotals() {
    if ($totalNet) $totalNet.textContent = '';
    if ($totalGross) $totalGross.textContent = '';
  }

  // ---------- quote snapshot (additive, read-only) ----------
  // Feeds the B2B "Angebot anfordern" popup. It NEVER changes a price, never
  // writes a cart property and never touches the DOM — it only reports numbers
  // this file has ALREADY calculated, so the B2B app can re-price the same
  // configuration at another customer tier without a second pricing engine.
  //
  // The app repeats exactly these lines and nothing else:
  //   FORMULA / FIXED_MC     net = round((base * cf * cgf * qf + fixedAdds) * 100)
  //   HANDELSWARE_STANDARD   net = round(base * cf * krf * qf * 100) + hw cents
  //   AREA_FIX / HW_FIXED    no factors at all -> a tier change cannot move it
  var PXQ_VERSION = '2026-09-08-a';
  var pxQuote = null;
  function pxNum(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }
  function pxCfgBlob() {
    if (!form) return null;
    var el = form.querySelector('input[type="hidden"][name="properties[_cfg]"]');
    if (!el || !el.value) return null;
    try { return JSON.parse(el.value); } catch (e) { return null; }
  }
  function pxSnap(o) {
    try {
      o.pxq = PXQ_VERSION;
      o.v = CFG.version || null;
      o.articleNo = CFG.articleNo || null;
      o.variantId = selectedVariantId() || null;
      o.cf = pxNum(CFG.factors && CFG.factors.cf, 1);
      o.cgf = pxNum(CFG.factors && CFG.factors.cgf, 1);
      o.krf = pxNum(CFG.factors && CFG.factors.krf, 1);
      o.vat = pxNum(CFG.settings && CFG.settings.vat, 0);
      o.tier = (CFG.factors && CFG.factors.tier !== undefined) ? CFG.factors.tier : null;
      o.country = (CFG.factors && CFG.factors.country) || null;
      o.lang = lang;
      if (o.qty === undefined || o.qty === null) o.qty = getQty();
      if (o.fixedAddsEur === undefined) o.fixedAddsEur = 0;
      if (o.hwTextileCents === undefined) o.hwTextileCents = 0;
      if (o.hwPdUnitCents === undefined) o.hwPdUnitCents = 0;
      if (o.hwCatalogueCents === undefined) o.hwCatalogueCents = 0;
      if (o.overThreshold === undefined) o.overThreshold = false;
      if (o.cfg === undefined) o.cfg = pxCfgBlob();
      var ad = addonSelection();
      o.addon = ad ? {
        variantId: ad.variantId, title: ad.title || '',
        baseCents: ad.baseCents, netCents: addonUnitNetCents(o.qty)
      } : null;
      pxQuote = o;
    } catch (e) {
      // A snapshot must never be able to break the price display.
      console.warn('PXQ: snapshot failed', e);
      pxQuote = null;
    }
  }
  // Over-threshold: the configurator deliberately refuses to show a price
  // ("ab X Stueck erstellen wir Ihnen gerne ein individuelles Angebot"). That is
  // the strongest possible reason to want a quote, so we still capture the
  // configuration and the pre-factor cost and let PRIMEX price it.
  function pxSnapNoPrice(model, baseEur, qty) {
    pxSnap({
      model: model, overThreshold: true, baseEur: baseEur,
      qf: null, qty: qty, netCents: null, grossCents: null,
      cfg: {
        a: CFG.articleNo,
        b: $w ? (readDim($w) || null) : null,
        h: $h ? (readDim($h) || null) : null,
        t: $t ? (readDim($t) || null) : null,
        qty: qty, lang: lang, v: CFG.version
      }
    });
  }
  window.PXP_quoteSnapshot = function () {
    try { return pxQuote ? JSON.parse(JSON.stringify(pxQuote)) : null; }
    catch (e) { return null; }
  };
  console.log('[PXQ] quote snapshot ready ' + PXQ_VERSION);

  /* ---------- v15.1: Mindestabrechnungsfläche hint — AREA_FIX ONLY ----------
     DISPLAY ONLY. It builds its own element, so primex-configurator.liquid is
     not modified. It writes no cart property, never reads or changes
     _calculated_price, _cfg or PXP_quoteSnapshot, and only reports the area
     compute() has ALREADY calculated. It is reached exclusively from the
     AREA_FIX branch, so no other product category can render it. */
  var $areaNote = null;
  function areaNoteEl() {
    if ($areaNote && $areaNote.isConnected) return $areaNote;
    var anchor = root.querySelector('.px-dim-hints') || document.getElementById('px-dim-error');
    if (!anchor || !anchor.parentNode) return null;
    $areaNote = document.createElement('div');
    $areaNote.id = 'px-area-note';
    $areaNote.style.cssText = 'font-size:12px;line-height:1.45;margin:4px 0 2px';
    anchor.parentNode.insertBefore($areaNote, anchor.nextSibling);
    return $areaNote;
  }
  function fmtArea(m2) {
    try {
      return new Intl.NumberFormat(L.fmtLocale,
        { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(m2);
    } catch (e) { return String(Math.round(m2 * 100) / 100); }
  }
  function showAreaNote(b, h, aRaw, aBilled) {
    var el = areaNoteEl();
    if (!el) return;
    if (!b || !h) { el.textContent = ''; return; }
    var atMin = aBilled > aRaw;
    el.textContent = L.areaNote(fmtDimDisplay(b), fmtDimDisplay(h), fmtArea(aRaw)) +
                     (atMin ? '  ' + L.areaMin(fmtArea(aBilled)) : '');
    el.style.color = atMin ? '#cb181b' : '#6b6b6b';
  }
  function hideAreaNote() {
    var el = document.getElementById('px-area-note');
    if (el) el.textContent = '';
  }

  // ---------- pricing core ----------
  function findTier(b) {
    var tiers = CFG.formula.tiers || [];
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      var minOk = (t.minB === undefined) || b >= t.minB;
      var maxOk = (t.maxB === undefined) || b <= t.maxB;
      if (minOk && maxOk) return t;
    }
    return null;
  }
  function pickTier(b) {
    var t = findTier(b);
    // v15.3: tiers are written in whole cm ("maxB 250" / "minB 251"), which
    // leaves 250,1–250,9 in no tier. Such a decimal belongs to the next tier up.
    if (!t && b !== Math.ceil(b)) t = findTier(Math.ceil(b));
    return t;
  }

  function qtyFactor(qty) {
    if (qty > CFG.settings.qtyThreshold) return null;
    var list = CFG.qtyFactors || [];
    for (var i = 0; i < list.length; i++) {
      if (qty >= list[i].min && qty <= list[i].max) {
        var f = list[i].factor;
        if (typeof f !== 'number' || f < 0.5 || f > 1.5) {
          console.error('PX: invalid quantity factor', f, 'for qty', qty, '- using 1.0. Fix the metaobject entry!');
          return 1.0;
        }
        return f;
      }
    }
    return 1.0;
  }

  function fabricFromSelect(sel) {
    if (!sel || sel.selectedIndex < 0) return null;
    var opt = sel.options[sel.selectedIndex];
    // Disabled fabric options are never valid pricing/cart selections.
    if (!opt || !opt.value || opt.disabled) return null;
    return {
      articleNo: opt.value,
      mc: parseFloat(opt.dataset.mc),
      title: opt.dataset.title || opt.text,
      noPrint: opt.dataset.noprint === '1'
    };
  }
  function selectedFabric() {
    if (!textileOnFn()) return null;
    // v14.11: motif-only products have no fabric-TYPE select at all — return a
    // synthetic fab so printedFn/selectedPrintData/upload still switch on;
    // computeMCT() below guarantees this never adds any cost.
    // v14.20: EXCEPT when "showFabricSelect":true (Akustikbild family, 9
    // products) — these DO show a real fabric dropdown (e.g. white vs 615007),
    // it is just a production/cosmetic choice with zero price impact, since
    // computeMCT() zeroes the cost purely from the motifOnly flag either way.
    if (CFG.formula && CFG.formula.motifOnly) {
      if (CFG.formula.showFabricSelect) return fabricFromSelect($fabricSelect);
      return { articleNo: CFG.articleNo, mc: 0, title: '', noPrint: false };
    }
    // v15.8: tagged round product — its one linked fabric, hidden but PRICED.
    // Without a linked fabric: a placeholder that is never priced.
    if (CFG.motifOnly === true) {
      var mf = CFG.motifFabric;
      if (mf && mf.articleNo) {
        return {
          articleNo: String(mf.articleNo),
          mc: parseFloat(mf.mc) || 0,
          title: mf.title || '',
          noPrint: mf.noPrint === true,
          maxw: parseFloat(mf.maxw) || 0,
          maxl: parseFloat(mf.maxl) || 0
        };
      }
      return { articleNo: CFG.articleNo, mc: 0, title: '', noPrint: false, placeholder: true };
    }
    return fabricFromSelect($fabricSelect);
  }
  // v13: back-side fabric for dualFabric (freestanding) products
  function selectedFabric2() {
    if (!textileOnFn() || !CFG.formula || !CFG.formula.dualFabric) return null;
    // A real back-side select is authoritative. Never fall back to a front fabric
    // if the back-side option is disabled/invalid.
    if ($fabricSelect2) return fabricFromSelect($fabricSelect2);
    return selectedFabric();
  }

  function selectedColor() {
    var el = root.querySelector('input[name="px-fcolor"]:checked');
    if (!el) return { code: 'SILVER', name: 'Silber', surcharge: 0, isRal: false };
    var isRal = el.dataset.ral === '1';
    return {
      code: el.value,
      name: isRal ? L.ralOption : (el.dataset.name || el.value),
      surcharge: parseFloat(el.dataset.surcharge || '0') || 0,
      useFormula: el.dataset.formula === '1',
      isRal: isRal
    };
  }

  function selectedCable() {
    if (!$cableSelect) return null;
    // .name becomes properties[Kabelausgang] — a CART VALUE, so frozen German.
    // (The other L.pos() call, on the cable SVG's aria-label, stays translated.)
    return { code: $cableSelect.value, name: PKEY.pos($cableSelect.value) };
  }

  function designAllowed(fab) {
    return printedFn(fab) && !!$designWrap;
  }

  function selectedDesign(fab) {
    if (!designAllowed(fab) || !$designToggle || !$designToggle.checked) return null;
    var panel = root.querySelector('.px-design-panel.px-active-panel') || root.querySelector('.px-design-panel');
    if (!panel) return null;
    var r = panel.querySelector('input[type="radio"]:checked') || panel.querySelector('input[type="radio"]');
    if (!r) return null;
    // Entering catalogue mode must always represent a concrete motif. This also
    // keeps AREA_FIX and ordinary single-textile products aligned with the card UIs.
    if (!r.checked) r.checked = true;
    return { code: r.value, name: r.dataset.name || r.value, price: parseFloat(r.dataset.price || '0') || 0 };
  }

  // v15.5: catalogue price parsing + card-published surcharge helpers.
  // Some Shopify metaobject money/text fields can arrive as "85", "85,00",
  // "85.00 EUR" or "€85,00". Native parseFloat() fails for the last form
  // and can silently turn a valid catalogue selection into a zero surcharge.
  function parseCataloguePrice(raw) {
    if (raw === null || raw === undefined) return 0;
    if (typeof raw === 'number') return isFinite(raw) && raw > 0 ? raw : 0;
    var str = String(raw).trim().replace(/\s+/g, '').replace(/[^0-9,.-]/g, '');
    if (!str) return 0;
    var comma = str.lastIndexOf(',');
    var dot = str.lastIndexOf('.');
    if (comma > -1 && dot > -1) {
      // The last separator is the decimal separator; remove the other one(s).
      if (comma > dot) str = str.replace(/\./g, '').replace(',', '.');
      else str = str.replace(/,/g, '');
    } else if (comma > -1) {
      str = str.replace(',', '.');
    }
    var value = parseFloat(str);
    return isFinite(value) && value > 0 ? value : 0;
  }

  // Catalogue motifs are currently a fixed 85 EUR service in the shop. Prefer
  // the actual metaobject value whenever it is present, but never allow a valid
  // Katalogmotiv choice to become price-neutral because a card-side data-price
  // was missing/stale. This is deliberately used ONLY after catalogue mode has
  // been positively established.
  function cataloguePriceOrFallback(raw) {
    return parseCataloguePrice(raw) || 85;
  }

  // Card UIs publish their current catalogue surcharge directly on
  // #px-configurator. A published ZERO is not authoritative: older/stale card
  // state can publish 0 before the hidden per-card motif price is populated, so
  // callers must fall back to the real card/motif DOM in that case.
  function cardCatalogueSurcharge(mode) {
    if (!root || root.dataset.pxCataloguePricingMode !== mode) return null;
    var value = parseCataloguePrice(root.dataset.pxCatalogueSurcharge || '0');
    return value > 0 ? value : 0;
  }

  // v13 client point 6: when a catalogue motif is chosen, print data is hidden AND not charged
  function selectedPrintData(fab, dsg) {
    if (!printedFn(fab) || dsg || !$pdSelect) return null;
    var opt = $pdSelect.options[$pdSelect.selectedIndex];
    if (!opt) return null;
    return { code: opt.value, name: opt.dataset.name || opt.text, price: parseFloat(opt.dataset.mc || '0') || 0 };
  }

  // v14.40: dualFabric front/back artwork is independent in the card UI.
  // The UI stores each side in hidden .px-dual-design-* inputs. The core
  // reads those values at compute/cart time, so switching the active card can
  // never change the other side's state. Base frame/fabric formulas are untouched.
  function dualUiReady() {
    if (!(CFG.formula && CFG.formula.dualFabric && $textileSection)) return false;
    // The card script is deferred and creates its hidden state after this core
    // file initializes. Accept either its ready flag OR the real per-side state
    // inputs, so a pricing refresh can never fall back to the single-textile
    // catalogue path merely because of script timing.
    return root.dataset.pxDualUiReady === '1' || !!$textileSection.querySelector('.px-dual-design-mode');
  }
  function dualStateInput(kind, side) {
    return dualUiReady() ? $textileSection.querySelector('.px-dual-design-' + kind + '[data-side="' + side + '"]') : null;
  }
  function dualSideMode(side) {
    var el = dualStateInput('mode', side);
    var v = el ? el.value : 'upload';
    return (v === 'catalog' || v === 'unprinted') ? v : 'upload';
  }
  function dualSideDesign(side) {
    var code = dualStateInput('code', side);
    var name = dualStateInput('name', side);
    var image = dualStateInput('image', side);
    var price = dualStateInput('price', side);
    return {
      code: code ? code.value : '',
      name: name ? name.value : '',
      image: image ? image.value : '',
      price: price ? (parseFloat(price.value || '0') || 0) : 0
    };
  }
  function dualAnyOwnUpload() {
    return dualUiReady() && (dualSideMode('front') === 'upload' || dualSideMode('back') === 'upload');
  }
  function dualSelectedPrintData() {
    if (!dualAnyOwnUpload() || !$pdSelect) return null;
    var opt = $pdSelect.options[$pdSelect.selectedIndex];
    if (!opt) return null;
    return { code: opt.value, name: opt.dataset.name || opt.text, price: parseFloat(opt.dataset.mc || '0') || 0 };
  }
  function dualCatalogueDesignForPricing() {
    if (!dualUiReady()) return null;
    // Representative motif for legacy/global cart fields. Per-side production
    // properties are written separately by writeProps().
    var sides = ['front', 'back'];
    for (var i = 0; i < sides.length; i++) {
      if (dualSideMode(sides[i]) !== 'catalog') continue;
      var d = dualSideDesign(sides[i]);
      if (d.code) return d;
    }
    return null;
  }
  function dualCataloguePriceForPricing() {
    if (!dualUiReady()) return 0;

    // A positive card-published value is safe to use. Never accept published 0
    // as final because it can precede the motif-price state update.
    var published = cardCatalogueSurcharge('dual');
    if (published !== null && published > 0) return published;

    // Resolve FRONT and BACK independently. dualFabric is the only product
    // family where catalogue artwork is charged once per selected side.
    var total = 0;
    ['front', 'back'].forEach(function (side) {
      var mode = dualSideMode(side);
      // Dataset fallback keeps this robust even if the dynamically-created hidden
      // input is momentarily unavailable while switching the active card.
      if (mode !== 'catalog') {
        var dataMode = side === 'front' ? root.dataset.pxDualModeFront : root.dataset.pxDualModeBack;
        if (dataMode !== 'catalog') return;
      }

      var d = dualSideDesign(side);
      var price = parseCataloguePrice(d.price);

      // If the per-side hidden price is empty, resolve it from the original
      // catalogue radio by motif code. Both cards reuse this immutable source.
      if (!price && d.code && $designWrap) {
        var radios = $designWrap.querySelectorAll('.px-design-panel input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          if ((radios[i].value || '') === d.code) {
            price = parseCataloguePrice(radios[i].dataset.price || '0');
            if (price) break;
          }
        }
      }

      // A side in catalogue mode is a chargeable catalogue service even if an
      // older/stale UI build omitted data-price. Current shop rule: 85 EUR/side.
      total += cataloguePriceOrFallback(price);
    });
    return total;
  }

  function validate(b, h, t) {
    var lim = CFG.limits;
    var needT = lim.minT > 0;
    if (!b || !h || (needT && !t)) return L.enter;

    if (b < lim.minB) return L.errRange(L.width, lim.minB, lim.maxB);
    if (h < lim.minH) return L.errRange(L.height, lim.minH, lim.maxH);

    // AREA_FIX / standalone Stoffbanner: the print may be rotated by 90 degrees.
    // maxB is the maximum production/fabric width and maxH is the maximum
    // production/fabric length for this standalone banner product.
    if (CFG.formula && CFG.formula.kind === 'AREA_FIX') {
      var normalFits = b <= lim.maxB && h <= lim.maxH;
      var rotatedFits = h <= lim.maxB && b <= lim.maxH;
      if (!normalFits && !rotatedFits) {
        return L.errRange(L.width, lim.minB, Math.max(lim.maxB, lim.maxH));
      }
    } else {
      if (b > lim.maxB) return L.errRange(L.width, lim.minB, lim.maxB);
      if (h > lim.maxH) return L.errRange(L.height, lim.minH, lim.maxH);
    }

    if (needT && (t < lim.minT || t > lim.maxT)) return L.errRange(L.depth, lim.minT, lim.maxT);
    return null;
  }

  // ---- formula-shape helpers ----
  function lengthMeters(rule, b, h, t) {
    switch (rule) {
      case 'L4BHT': return 4 * (b + h + (t || 0)) / 100;
      case 'L2B': return (2 * b) / 100;
      case 'LUSHAPE': return (4 * (h + (t || 0)) + 2 * b) / 100;
      case 'LLSHAPE': return (2 * (b + (t || 0)) + 3 * h) / 100;
      default: return 2 * (b + h) / 100;
    }
  }
  function ralPerimeterMeters(rule, b, h, t) {
    switch (rule) {
      case 'P2B': return (2 * b) / 100;
      case 'PCUBE': return 4 * (b + h + (t || 0)) / 100;
      case 'PUSHAPE': return (4 * (h + (t || 0)) + 2 * b) / 100;
      case 'PLSHAPE': return (2 * (b + (t || 0)) + 3 * h) / 100;
      case 'PCIRCLE': return (Math.PI * b) / 100; // b = diameter in cm here
      case 'P2BH':
      default: return 2 * (b + h) / 100;
    }
  }
  function panelArea(code, b, h, t) {
    switch (code) {
      case 'BT': return (b * (t || 0)) / 10000;
      case 'BH': return (b * h) / 10000;
      case 'TH': return ((t || 0) * h) / 10000;
      default: return 0;
    }
  }
  function computeMCR(b, h, t, dim) {
    var F = CFG.formula;
    var dimVal = (F.tierDim === 'MAX_BT') ? Math.max(b, t || 0) : b;
    if (F.kind === 'QUAD_L') {
      if (!F.quad) return null;
      var Lm = lengthMeters(F.lengthRule || 'L4BHT', b, h, t);
      return F.quad.a * Lm * Lm + F.quad.b * Lm + F.quad.c;
    }
    var tier = pickTier(dimVal);
    if (!tier) return null;
    var coeff = (dim && tier.coeffDim !== undefined) ? tier.coeffDim : tier.coeff;
    // constantDim is optional. If it is absent, dimming must not turn the price into NaN.
    var cnst = (dim && tier.constantDim !== undefined) ? tier.constantDim : tier.constant;
    if (F.kind === 'LINEAR_L') {
      var L2 = lengthMeters(F.lengthRule || 'L4BHT', b, h, t);
      return coeff * L2 + (cnst || 0);
    }
    var A = (b * h) / 10000;
    return coeff * A + cnst;
  }
  // v13: dualFabric products price front + back fabric separately
  function computeMCT(fab, fab2, b, h, t) {
    if (!fab) return 0;
    // v14.11: motif-only products (606445/606103/606447) already have BOTH
    // textiles baked into the frame's HKR,T formula ("Rahmen mit 2 Textilien").
    // The upload zones are for the customer's motif image only — never a cost.
    if (CFG.formula && CFG.formula.motifOnly) return 0;
    var A = (b * h) / 10000;
    if (CFG.formula && CFG.formula.dualFabric) {
      var f2 = fab2 || fab;
      return (A * fab.mc + CFG.settings.fabricFlat) + (A * f2.mc + CFG.settings.fabricFlat);
    }
    var mode = activeFabricMode();
    if (mode && mode.panels) {
      var sum = 0;
      for (var i = 0; i < mode.panels.length; i++) {
        var pnl = mode.panels[i];
        sum += (pnl.n || 1) * (panelArea(pnl.area, b, h, t) * fab.mc + CFG.settings.fabricFlat);
      }
      return sum;
    }
    return A * fab.mc + CFG.settings.fabricFlat;
  }

  // ---------- Fabric fit / rotation logic ----------
  // A print may be rotated by 90 degrees during production. Product/frame
  // dimensions themselves are NEVER changed here.
  function fabricFit(width, height, fabricWidth, fabricLength) {
    width = parseFloat(width) || 0;
    height = parseFloat(height) || 0;
    fabricWidth = parseFloat(fabricWidth) || 0;
    fabricLength = parseFloat(fabricLength) || 0;

    // Missing dimensions: do not disable the fabric.
    if (!width || !height || !fabricWidth) {
      return {
        available: true,
        rotated: false,
        productionWidth: width,
        productionLength: height
      };
    }

    // Backwards-compatible while max_length_cm is being populated. A blank
    // max length means no additional length restriction yet.
    if (!fabricLength) fabricLength = Infinity;

    // Normal orientation: Width x Height.
    if (width <= fabricWidth && height <= fabricLength) {
      return {
        available: true,
        rotated: false,
        productionWidth: width,
        productionLength: height
      };
    }

    // Rotated orientation: Height x Width.
    if (height <= fabricWidth && width <= fabricLength) {
      return {
        available: true,
        rotated: true,
        productionWidth: height,
        productionLength: width
      };
    }

    return {
      available: false,
      rotated: false,
      productionWidth: null,
      productionLength: null
    };
  }

  // Returns the physical textile rectangles required by the current product.
  // Normal and dualFabric products use B x H. Panel-based 3D products use
  // their existing fabricModes definitions (BH / BT / TH).
  function requiredFabricRects(b, h, t) {
    var mode = activeFabricMode();
    var rects = [];

    if (mode && mode.panels && mode.panels.length) {
      mode.panels.forEach(function (panel) {
        var w = 0;
        var l = 0;

        if (panel.area === 'BH') {
          w = b;
          l = h;
        } else if (panel.area === 'BT') {
          w = b;
          l = t;
        } else if (panel.area === 'TH') {
          w = t;
          l = h;
        }

        if (w > 0 && l > 0) rects.push({ width: w, height: l });
      });

      if (rects.length) return rects;
    }

    if (b > 0 && h > 0) rects.push({ width: b, height: h });
    return rects;
  }

  function applyFabricAvailabilityToSelect(sel, rects, ignoreLimit) {
    if (!sel) return false;

    var oldIndex = sel.selectedIndex;

    // Preserve the existing Formula JSON exception exactly as before.
    if (ignoreLimit) {
      for (var k = 0; k < sel.options.length; k++) sel.options[k].disabled = false;
      if (sel.selectedIndex < 0 && sel.options.length) sel.selectedIndex = 0;
      return oldIndex !== sel.selectedIndex;
    }

    for (var i = 0; i < sel.options.length; i++) {
      var option = sel.options[i];
      var fabricWidth = parseFloat(option.dataset.maxw || '0') || 0;
      var fabricLength = parseFloat(option.dataset.maxl || '0') || 0;
      var available = true;
      var firstFit = null;

      for (var r = 0; r < rects.length; r++) {
        var fit = fabricFit(
          rects[r].width,
          rects[r].height,
          fabricWidth,
          fabricLength
        );
        if (!firstFit) firstFit = fit;
        if (!fit.available) {
          available = false;
          break;
        }
      }

      option.disabled = !available;

      // Store the production orientation for ordinary one-panel products.
      // Area-based price calculation stays unchanged.
      if (available && rects.length === 1 && firstFit) {
        option.dataset.productionWidth = String(firstFit.productionWidth);
        option.dataset.productionLength = String(firstFit.productionLength);
        option.dataset.productionRotated = firstFit.rotated ? '1' : '0';
      } else {
        delete option.dataset.productionWidth;
        delete option.dataset.productionLength;
        delete option.dataset.productionRotated;
      }
    }

    // If the selected fabric no longer fits, use the first available fabric.
    if (
      sel.selectedIndex < 0 ||
      (sel.options[sel.selectedIndex] && sel.options[sel.selectedIndex].disabled)
    ) {
      sel.selectedIndex = -1;
      for (var j = 0; j < sel.options.length; j++) {
        if (!sel.options[j].disabled) {
          sel.selectedIndex = j;
          break;
        }
      }
    }

    return oldIndex !== sel.selectedIndex;
  }

  function updateFabricAvailability(b, h, t) {
    var ignoreLimit = !!(CFG.formula && CFG.formula.ignoreFabricWidthLimit);
    var rects = requiredFabricRects(b, h, t);

    [$fabricSelect, $fabricSelect2].forEach(function (sel) {
      applyFabricAvailabilityToSelect(sel, rects, ignoreLimit);
    });
  }

  function updateTextileUI(fab) {
    var on = textileOnFn();
    if ($textileSection) $textileSection.style.display = on ? 'block' : 'none';
    if ($fabricInfo) {
      var opt = $fabricSelect ? $fabricSelect.options[$fabricSelect.selectedIndex] : null;
      var info = opt ? (tooltipFor(opt.dataset.title || opt.text) || opt.dataset.info) : null;
      if (on && info) { $fabricInfo.textContent = info; $fabricInfo.style.display = 'block'; }
      else { $fabricInfo.style.display = 'none'; }
    }
    var printable = printedFn(fab);
    var designOn = printable && $designToggle && $designToggle.checked;

    // dualFabric v14.40: the shared editor represents only the currently active
    // side. Never clear/hide the OTHER side's upload or motif from this global
    // helper. primex-textile-cards.js owns per-side visibility and stale-file
    // cleanup; print-data stays visible whenever either side uses Eigene Datei.
    if (dualUiReady()) {
      if ($pdWrap) $pdWrap.style.display = dualAnyOwnUpload() ? 'block' : 'none';
      if ($designWrap) $designWrap.style.display = 'block';
      if ($designArea) $designArea.style.display = 'block';
      return;
    }

    // client point 6: catalogue motif chosen -> hide print data
    if ($pdWrap) $pdWrap.style.display = (printable && !designOn) ? 'block' : 'none';
    if ($designWrap) $designWrap.style.display = printable ? 'block' : 'none';
    // upload and catalogue are mutually exclusive; both hidden when Ohne Druck
    $pfUpWraps.forEach(function (w) {
      w.style.display = (printable && !designOn) ? 'block' : 'none';
    });
    if (designOn && anyFiles()) clearAllFiles();
    if (!printable) {
      if ($designToggle && $designToggle.checked) $designToggle.checked = false;
      if (anyFiles()) clearAllFiles();
    }
    if ($designArea) $designArea.style.display = designOn ? 'block' : 'none';
  }

  // v13.9: the scenario can be defined PER VARIANT (variant metafield custom.variant_scenario).
  // Resolution order: the selected variant's own scenario FIRST, then the product-level
  // scenario as the default. Products that only carry the product-level metafield are
  // therefore completely unaffected.
  //
  // v15.1: read the LAST ENABLED input named "id", and complain loudly if there
  // is more than one. Shopify resolves a duplicated form field to the LAST
  // value, so that is the variant which actually reaches the cart — and the
  // price this file calculates must describe THAT variant. With the duplicate
  // removed from buy-buttons.liquid there is exactly one input and this is
  // identical to the old querySelector(); it exists so a future duplicate can
  // never again produce a cart line with the wrong variant at the right
  // variant's price.
  var pxWarnedDupVariantInput = false;
  function selectedVariantId() {
    if (!form) return null;
    var nodes = form.querySelectorAll('[name="id"]');
    if (!nodes.length) return null;
    if (nodes.length > 1 && !pxWarnedDupVariantInput) {
      pxWarnedDupVariantInput = true;
      console.error('PX: the product form contains ' + nodes.length +
        ' inputs named "id". Shopify receives ALL of them and uses the last, so the ' +
        'cart can get the wrong variant. Remove the duplicate in buy-buttons.liquid.');
    }
    var chosen = null;
    for (var i = 0; i < nodes.length; i++) { if (!nodes[i].disabled) chosen = nodes[i]; }
    return chosen ? chosen.value : null;
  }
  function effectiveScenario() {
    var vid = selectedVariantId();
    var vs = (CFG.variantScenarios && vid) ? CFG.variantScenarios[vid] : null;
    if (vs) return vs;
    return CFG.scenario || null;
  }
  // true if this product is priced by ANY scenario (product-level or on at least one variant)
  function hasScenarioSetup() {
    if (CFG.scenario) return true;
    if (CFG.variantScenarios) {
      for (var k in CFG.variantScenarios) {
        if (CFG.variantScenarios[k]) return true;
      }
    }
    return false;
  }

  // v14.6: parse "100 cm" (or "Ø 100 cm") from the selected variant title —
  // round products (FIXED_MC) have exactly one size dimension, the diameter.
  function fixedMcDiameterCm() {
    var vid = selectedVariantId();
    var title = (CFG.variantTitles && vid) ? CFG.variantTitles[vid] : null;
    if (!title) return null;
    var m = String(title).match(/(\d+(?:[.,]\d+)?)/);
    if (!m) return null;
    var d = parseFloat(m[1].replace(',', '.'));
    return d > 0 ? d : null;
  }

  // v14.0: parse "200 x 250 cm" (also "300 x 250cm") from the selected variant title
  function hwVariantDims() {
    var vid = selectedVariantId();
    var title = (CFG.variantTitles && vid) ? CFG.variantTitles[vid] : null;
    if (!title) return null;
    var m = String(title).match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    if (!m) return null;
    var b = parseFloat(m[1].replace(',', '.'));
    var h = parseFloat(m[2].replace(',', '.'));
    if (!b || !h) return null;
    return { b: b, h: h };
  }
  function hwSlotFabric(i) {
    var sel = $hwWrap ? $hwWrap.querySelector('.px-hw-fabric[data-slot="' + i + '"]') : null;
    if (!sel) return null;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return null;
    return { articleNo: opt.value, mc: parseFloat(opt.dataset.mc), title: opt.dataset.title || opt.text };
  }
  // v14.31+: every Handelsware/Messesystem textile slot has its own design mode.
  // The motif choice is stored per slot for production, but the catalogue service
  // surcharge is PRODUCT-level for Messesystem/Handelsware: add it only ONCE when
  // one or more active slots use catalogue mode. dualFabric Formula products are
  // different: front and back are two independently printed sides and are charged
  // once PER selected catalogue side (handled by dualCataloguePriceForPricing()).
  function hwStateInput(kind, i) {
    return $hwWrap ? $hwWrap.querySelector('.px-hw-design-' + kind + '[data-slot="' + i + '"]') : null;
  }
  function hwSlotMode(i) {
    var el = hwStateInput('mode', i);
    var v = el ? el.value : 'upload';
    return (v === 'catalog' || v === 'unprinted') ? v : 'upload';
  }
  function hwSlotDesign(i) {
    var code = hwStateInput('code', i);
    var name = hwStateInput('name', i);
    var image = hwStateInput('image', i);
    var price = hwStateInput('price', i);
    return {
      code: code ? code.value : '',
      name: name ? name.value : '',
      image: image ? image.value : '',
      price: price ? (parseFloat(price.value || '0') || 0) : 0
    };
  }

  function hwCatalogueUnitCents() {
    if (!$hwWrap) return 0;

    // Messesystem/Handelsware: ONE catalogue service surcharge for the entire
    // configured product, irrespective of whether 1, 2, 4 or 6 textile cards
    // use catalogue motifs. A positive card-published value can be used directly.
    var published = cardCatalogueSurcharge('hw');
    if (published !== null && published > 0) return Math.round(published * 100);

    // Resolve whether Stoffbanner is actually enabled from the REAL mode button.
    // Do not rely only on hwCount because the visual card script synchronizes
    // after the core click handler and an intermediate pricing pass may see 0.
    var activeBtn = $hwWrap.querySelector('#px-hw-modes .px-exec-btn.px-active');
    var activeCount = activeBtn ? (parseInt(activeBtn.dataset.count, 10) || 0) : hwCount;
    if (activeCount <= 0 && hwCount > 0) activeCount = hwCount;

    // Final UI-state fallback: when the generated card shell is visibly enabled,
    // use the number of physical textile slots. This cannot charge when "Ohne
    // Stoffbanner" is selected because that state hides the shell.
    if (activeCount <= 0) {
      var visibleShell = $hwWrap.querySelector('.pxhw-shell:not([hidden])');
      if (visibleShell) activeCount = $hwWrap.querySelectorAll('.px-hw-slot').length;
    }
    if (activeCount <= 0) return 0;

    var catalogueFound = false;
    for (var i = 1; i <= activeCount; i++) {
      if (hwSlotMode(i) !== 'catalog') continue;
      catalogueFound = true;
      var d = hwSlotDesign(i);
      var price = parseCataloguePrice(d.price);

      // Resolve from the immutable catalogue source if the dynamic per-card
      // price field was created after the pricing script initialized.
      if (!price && d.code) {
        var tiles = $hwWrap.querySelectorAll('#px-hw-catalog-source .px-hw-catalog-tile');
        for (var j = 0; j < tiles.length; j++) {
          if ((tiles[j].dataset.code || '') === d.code) {
            price = parseCataloguePrice(tiles[j].dataset.price || '0');
            if (price) break;
          }
        }
      }

      // ONE charge for the entire Messesystem product. Once any active card is
      // catalogue mode we can return immediately.
      return Math.round(cataloguePriceOrFallback(price) * 100);
    }

    return catalogueFound ? 8500 : 0;
  }
  function hwAnyOwnUpload() {
    if (!$hwWrap || hwCount === 0) return false;
    for (var i = 1; i <= hwCount; i++) {
      if (hwSlotMode(i) === 'upload') return true;
    }
    return false;
  }
  function hwModeText(mode, lg) {
    if (mode === 'catalog') return lg === 'en' ? 'Catalogue motif' : 'Katalogmotiv';
    if (mode === 'unprinted') return lg === 'en' ? 'Unprinted' : 'Unbedruckt';
    return lg === 'en' ? 'Own file' : 'Eigene Datei';
  }
  function hwDesignPropName(lg, i) {
    return (lg === 'en' ? 'Design textile banner ' : 'Gestaltung Stoffbanner ') + i;
  }
  function hwMotifPropName(lg, i) {
    return (lg === 'en' ? 'Catalogue motif textile banner ' : 'Katalogmotiv Stoffbanner ') + i;
  }
  function hwSelectedPd() {
    // The existing one-time print-data fee applies only when at least one
    // active textile uses the customer's own file. Catalogue and unprinted
    // slots therefore no longer trigger that fee.
    if (!$hwPdSelect || hwCount === 0 || !hwAnyOwnUpload()) return null;
    var opt = $hwPdSelect.options[$hwPdSelect.selectedIndex];
    if (!opt) return null;
    return { code: opt.value, name: opt.dataset.name || opt.text, price: parseFloat(opt.dataset.mc || '0') || 0 };
  }
  // v14.3 — Wolfgang Kapitel 4 (Stand 08/2026):
  //   VKT = MTF (1,7) x SUM over slots of (A_i x HKT_i + 4,45)   — a FIX price:
  //   NO country factor, NO customer-group factor, NO quantity factor.
  //   A_i: the slot's fixed area_m2 if set, otherwise B x H from the variant title.
  //   Applies to HANDELSWARE_STANDARD and HANDELSWARE_FIXED alike.
  function hwSlotArea(i) {
    var slot = $hwWrap ? $hwWrap.querySelector('.px-hw-slot[data-slot="' + i + '"]') : null;
    if (slot && slot.dataset.area) {
      var a = parseFloat(String(slot.dataset.area).replace(',', '.'));
      if (a > 0) return a;
    }
    var dims = hwVariantDims();
    if (!dims) return NaN;
    return (dims.b * dims.h) / 10000;
  }
  function hwTextileUnitCents() {
    if (!$hwWrap || hwCount === 0) return 0;
    var sum = 0;
    for (var i = 1; i <= hwCount; i++) {
      var fab = hwSlotFabric(i);
      var A = hwSlotArea(i);
      if (!fab || isNaN(A)) return NaN;
      sum += A * fab.mc + CFG.settings.fabricFlat;
    }
    var mtf = CFG.settings.mtf || 1.7;
    return Math.round(sum * mtf * 100);
  }
  function hwDynamicFabricPropName(s) {
    // v15.0: read the slot label from data-label, NOT from the visible text.
    // Client-side translation (Weglot) rewrites text nodes but never data-*
    // attributes, so this keeps the production property key stable in every
    // language. primex-configurator.liquid already renders
    //   data-label="{{ slot.label.value | default: 'Stoffbanner' | escape }}"
    // on .px-hw-slot — the identical string the old textContent read produced,
    // so EXISTING PROPERTY KEYS DO NOT CHANGE.
    var slotEl = $hwWrap ? $hwWrap.querySelector('.px-hw-slot[data-slot="' + s + '"]') : null;
    var slotLabel = slotEl ? String(slotEl.dataset.label || '').trim() : '';
    if (!slotLabel && slotEl) {
      var slotLabelEl = slotEl.querySelector('.px-label');
      slotLabel = (slotLabelEl && slotLabelEl.textContent.trim()) || '';
    }
    if (!slotLabel) slotLabel = PKEY.pFab + ' ' + s;
    return s + ':' + slotLabel;
  }
  function clearHwDynamicFabricProps() {
    if (!$hwWrap) return;
    for (var s = 1; s <= 6; s++) {
      setHidden('properties[' + hwDynamicFabricPropName(s) + ']', null);
      // Also remove generic keys produced by older builds, in both locales.
      setHidden('properties[' + DICT.de.pFab + ' ' + s + ']', null);
      setHidden('properties[' + DICT.en.pFab + ' ' + s + ']', null);
    }
  }
  function writeHwTextileProps(hwPd) {
    // Remove stale generic/dynamic fabric properties first, then write the current
    // physical slot labels (e.g. "1:Stoffbanner Theke hinten") for production.
    clearHwDynamicFabricProps();

    for (var s = 1; s <= 6; s++) {
      ['de', 'en'].forEach(function (lg) {
        setHidden('properties[' + hwDesignPropName(lg, s) + ']', null);
        setHidden('properties[' + hwMotifPropName(lg, s) + ']', null);
      });

      if (s <= hwCount) {
        var fb = hwSlotFabric(s);
        var mode = hwSlotMode(s);
        var design = hwSlotDesign(s);
        setHidden('properties[' + hwDynamicFabricPropName(s) + ']', fb ? (fb.title + ' (' + fb.articleNo + ')') : null);
        setHidden('properties[' + hwDesignPropName('de', s) + ']', hwModeText(mode, 'de'));
        setHidden('properties[' + hwMotifPropName('de', s) + ']',
          mode === 'catalog' && design.name ? design.name : null);
      }
    }

    // Clear the legacy English print-data key, then write the frozen German one.
    ['de', 'en'].forEach(function (lg) {
      setHidden('properties[' + DICT[lg].pPd + ']', null);
    });
    setHidden('properties[' + PKEY.pPd + ']', hwPd ? hwPd.name : null);

    // v15.1 — Ausführung for Handelsware, in BOTH states.
    //
    // HANDELSWARE_STANDARD and HANDELSWARE_FIXED were the ONLY scenarios that
    // wrote no visible cart property when the customer chose "Ohne
    // Stoffbanner": the whole loop above is skipped because hwCount is 0, so
    // the line reached the cart carrying only _calculated_price and _cfg —
    // both underscore-prefixed, therefore hidden from the customer and
    // filtered out by the theme. cart-drawer.liquid had nothing to list, so it
    // showed no "Konfiguration ansehen" toggle and no Bearbeiten link.
    //
    // The value is derived from hwCount and PKEY (frozen German), never from
    // the mode button's visible text, which Weglot and the re-skin layer in
    // primex-ui-enhancements.js both rewrite. Only written when this product
    // actually HAS a Stoffbanner block, so a Handelsware product without
    // textile_slots is unchanged.
    if ($hwWrap) {
      ['de', 'en'].forEach(function (lg) {
        setHidden('properties[' + DICT[lg].pExec + ']', null);
      });
      setHidden('properties[' + PKEY.pExec + ']', hwCount > 0 ? PKEY.withT : PKEY.withoutT);
    }
  }

  // E3/E4: fixed-size (round products) & merchandise — variant base value × factors
  // v13.7: + HANDELSWARE_STANDARD (SP x CF x KRF x QF) + HANDELSWARE_FIXED (no factors at all)
  function computeScenarioPrice() {
    var qty = getQty();
    var vid = selectedVariantId();
    var scen = effectiveScenario();

    // ---- HANDELSWARE_FIXED: identical price for every customer/country/quantity ----
    if (scen === 'HANDELSWARE_FIXED') {
      var fixedCents = (CFG.fixedPriceVariants && vid) ? parseInt(CFG.fixedPriceVariants[vid], 10) : 0;
      if (!fixedCents || fixedCents <= 0) { return fail(L.priceOnRequest); }
      // v14.3: Kapitel 4 textiles are added to Fixpreis products too
      var fxTex = hwTextileUnitCents();
      if (isNaN(fxTex)) { return fail(L.priceOnRequest); }
      var fxPd = hwSelectedPd();
      var fxPdUnitCents = fxPd ? Math.round(fxPd.price * 100 / qty) : 0;
      var fxCatalogueCents = hwCatalogueUnitCents();
      fixedCents = fixedCents + fxTex + fxPdUnitCents + fxCatalogueCents;
      var fGrossCents = Math.round(fixedCents * (1 + CFG.settings.vat));
      setErr('');
      $quote.style.display = 'none';
      $price.style.display = 'block';
      var adN = addonUnitNetCents(qty), adG = Math.round(adN * (1 + CFG.settings.vat));
      refreshAddonTiles();
      $net.textContent = fmt.format((fixedCents + adN) / 100);
      $gross.textContent = fmt.format((fGrossCents + adG) / 100);
      writeDisplayedTotals(fixedCents + adN, fGrossCents + adG, qty);
      if ($vatNote) $vatNote.textContent = L.vatNote(CFG.settings.vat);
      $line.textContent = L.lineTotal(qty, fmt.format(((fGrossCents + adG) * qty) / 100));
      showAddons(true);
      setSubmitEnabled(true);
      setHidden('properties[_calculated_price]', CFG.settings.taxesIncluded ? fGrossCents : fixedCents);
      writeHwTextileProps(fxPd);
      setHidden('properties[_cfg]', JSON.stringify({
        a: CFG.articleNo, scenario: scen, vid: vid, hwT: hwCount || null, qty: qty, lang: lang,
        net: fixedCents, gross: fGrossCents, v: CFG.version
      }));
      pxSnap({ model: 'HANDELSWARE_FIXED', baseEur: null, qf: 1,
               qty: qty, netCents: fixedCents, grossCents: fGrossCents });
      return;
    }

    // ---- HANDELSWARE_STANDARD: Standardpreis x Country x (NEW) Handelsware discount x Qty ----
    if (scen === 'HANDELSWARE_STANDARD') {
      var spCents = (CFG.standardPriceVariants && vid) ? parseInt(CFG.standardPriceVariants[vid], 10) : 0;
      if (!spCents || spCents <= 0) { return fail(L.priceOnRequest); }
      var hQf = qtyFactor(qty);
      if (hQf === null) {
        pxSnapNoPrice('HANDELSWARE_STANDARD', (spCents / 100), qty);
        $price.style.display = 'none';
        clearDisplayedTotals();
        $quote.textContent = L.quoteNote(CFG.settings.qtyThreshold);
        $quote.style.display = 'block';
        setErr(''); setSubmitEnabled(false); clearProps();
        return;
      }
      var hNet = (spCents / 100) * CFG.factors.cf * CFG.factors.krf * hQf;
      var hNetCents = Math.round(hNet * 100);
      // v14.3: textile FIX price (MTF model) — identical for every customer
      var hwTex = hwTextileUnitCents();
      if (isNaN(hwTex)) { return fail(L.priceOnRequest); }
      var hwPd = hwSelectedPd();
      var hwPdUnitCents = hwPd ? Math.round(hwPd.price * 100 / qty) : 0;
      var hwCatalogueCents = hwCatalogueUnitCents();
      hNetCents = hNetCents + hwTex + hwPdUnitCents + hwCatalogueCents;
      var hGrossCents = Math.round(hNetCents * (1 + CFG.settings.vat));
      setErr('');
      $quote.style.display = 'none';
      $price.style.display = 'block';
      var adN = addonUnitNetCents(qty), adG = Math.round(adN * (1 + CFG.settings.vat));
      refreshAddonTiles();
      $net.textContent = fmt.format((hNetCents + adN) / 100);
      $gross.textContent = fmt.format((hGrossCents + adG) / 100);
      writeDisplayedTotals(hNetCents + adN, hGrossCents + adG, qty);
      if ($vatNote) $vatNote.textContent = L.vatNote(CFG.settings.vat);
      $line.textContent = L.lineTotal(qty, fmt.format(((hGrossCents + adG) * qty) / 100));
      showAddons(true);
      setSubmitEnabled(true);
      setHidden('properties[_calculated_price]', CFG.settings.taxesIncluded ? hGrossCents : hNetCents);
      // textile cart properties (production needs to know what was ordered)
      writeHwTextileProps(hwPd);
      setHidden('properties[_cfg]', JSON.stringify({
        a: CFG.articleNo, scenario: scen, vid: vid, hwT: hwCount || null,
        tier: CFG.factors.tier, cty: CFG.factors.country, qty: qty, lang: lang,
        net: hNetCents, gross: hGrossCents, v: CFG.version
      }));
      pxSnap({ model: 'HANDELSWARE_STANDARD', baseEur: (spCents / 100), qf: hQf,
               hwTextileCents: hwTex, hwPdUnitCents: hwPdUnitCents,
               hwCatalogueCents: hwCatalogueCents,
               qty: qty, netCents: hNetCents, grossCents: hGrossCents });
      return;
    }

    // ---- FIXED_MC (round products): manufacturing cost x CF x CGF x QF
    //      v14.6: + optional frame colour surcharge, + optional fabric/textile
    //      add-on (circle area), + flat print-data fee — per Wolfgang/Katja
    //      ("Herstellkosten feste Abmessungen" doc §1). Fully opt-in: these are
    //      all zero/no-op unless the product actually links frame_colors and/or
    //      allowed_fabrics, so round products without them are UNCHANGED.
    //      v14.7: mc_cents can ALSO be entered directly in EUROS via the
    //      optional variant metafield custom.mc_euros (CFG.variantsEuros) — if
    //      present it wins; existing integer-cents products are untouched.
    //      v14.10: REMOVED the native-Price fallback (v14.8) per Wolfgang's
    //      confirmation — the HK must come from mc_cents or mc_euros ONLY. The
    //      variant's native Price field is used for other, unrelated purposes
    //      on the live theme and must never be read as the manufacturing cost.
    //      If neither metafield is filled in, the product correctly shows
    //      "price on request" instead of silently pulling the wrong number.
    var mcCents = 0;
    if (CFG.variantsEuros && vid && CFG.variantsEuros[vid]) {
      mcCents = Math.round(parseFloat(CFG.variantsEuros[vid]) * 100);
    } else if (CFG.variants && vid) {
      mcCents = parseInt(CFG.variants[vid], 10) || 0;
    }
    if (!mcCents || mcCents <= 0) { return fail(L.priceOnRequest); }

    var mcDiameter = fixedMcDiameterCm();
    var col = selectedColor();
    if ($colorName) $colorName.textContent = col.name;
    if ($ralWrap) $ralWrap.style.display = col.isRal ? 'block' : 'none';

    // Apply fabric availability BEFORE reading the selection so pricing/cart can
    // never retain a fabric that became invalid for this diameter.
    if (mcDiameter && ($fabricSelect || $fabricSelect2)) updateFabricAvailability(mcDiameter, mcDiameter, 0);
    var fixFab = selectedFabric();
    updateTextileUI(fixFab);
    if (textileOnFn() && $fabricSelect && !fixFab) return fail(L.errNoFabric);
    // v15.8: the hidden fabric of a tagged round product must still fit the
    // diameter — the same check the visible fabric list does for other products.
    if (CFG.motifOnly === true && fixFab && !fixFab.placeholder && mcDiameter &&
        !fabricFit(mcDiameter, mcDiameter, fixFab.maxw, fixFab.maxl).available) {
      return fail(L.errNoFabric);
    }

    var MCCOL = 0, MCSF = 0, MCT = 0;
    if (mcDiameter) {
      var circM = ralPerimeterMeters('PCIRCLE', mcDiameter, 0, 0);
      if (col.isRal) {
        MCSF = circM * CFG.settings.ralRate + CFG.settings.ralFlat;
      } else {
        MCCOL = col.useFormula ? (circM * CFG.settings.ralRate + CFG.settings.ralFlat) : col.surcharge;
      }
      // v15.8: priced for every real fabric, including the hidden one of a
      // tagged round product; only the no-fabric placeholder adds nothing.
      if (fixFab && !fixFab.placeholder) {
        var circAreaM2 = Math.PI * Math.pow(mcDiameter / 200, 2); // (diameter/2, cm->m)^2 x pi
        MCT = circAreaM2 * fixFab.mc + CFG.settings.fabricFlat;
      }
    }

    var qf = qtyFactor(qty);
    if (qf === null) {
      pxSnapNoPrice('FIXED_MC', (mcCents / 100 + MCT + MCCOL + MCSF), qty);
      $price.style.display = 'none';
      clearDisplayedTotals();
      $quote.textContent = L.quoteNote(CFG.settings.qtyThreshold);
      $quote.style.display = 'block';
      setErr('');
      setSubmitEnabled(false);
      clearProps();
      return;
    }
    // v14.17: round products were never checking the design-catalogue
    // selection at all (dsg was hardcoded to null) — this meant a catalogue
    // motif could never reach the cart on round products, and the "hide
    // print-data when a catalogue motif is chosen" rule could never trigger
    // there either, unlike formula products where both already worked.
    var fixDsg = selectedDesign(fixFab);
    var fixPd = selectedPrintData(fixFab, fixDsg);
    var fixFixedAdds = (fixPd ? fixPd.price : 0) + (fixDsg ? fixDsg.price : 0);

    var spNet = (mcCents / 100 + MCT + MCCOL + MCSF) * CFG.factors.cf * CFG.factors.cgf * qf + fixFixedAdds;
    var netCents = Math.round(spNet * 100);
    var grossCents = Math.round(netCents * (1 + CFG.settings.vat));
    setErr('');
    $quote.style.display = 'none';
    $price.style.display = 'block';
    var adN = addonUnitNetCents(qty), adG = Math.round(adN * (1 + CFG.settings.vat));
    refreshAddonTiles();
    $net.textContent = fmt.format((netCents + adN) / 100);
    $gross.textContent = fmt.format((grossCents + adG) / 100);
    writeDisplayedTotals(netCents + adN, grossCents + adG, qty);
    if ($vatNote) $vatNote.textContent = L.vatNote(CFG.settings.vat);
    $line.textContent = L.lineTotal(qty, fmt.format(((grossCents + adG) * qty) / 100));
    showAddons(true);
    setSubmitEnabled(true);
    setHidden('properties[_calculated_price]', CFG.settings.taxesIncluded ? grossCents : netCents);
    // v14.16: round products now go through the SAME shared writeProps() as
    // every other scenario — this is what actually fixes the missing cable
    // output property (selectedCable() is called here, exactly like the
    // formula-product path already did), and guarantees identical property
    // order across every product type from now on.
    writeProps({
      b: null, h: null, t: null, dim: false, dia: mcDiameter, exec: null,
      scenario: scen, vid: vid,
      fabric: fixFab ? fixFab.articleNo : null, fabricTitle: fixFab ? fixFab.title : null,
      fabric2: null, fabric2Title: null,
      printed: textileOnFn() ? printMode : null,
      color: col, ralCode: col.isRal && $ralCode ? $ralCode.value.trim() : null,
      pd: fixPd, dsg: fixDsg, cab: selectedCable(),
      qty: qty, netCents: netCents, grossCents: grossCents
    });
    pxSnap({ model: 'FIXED_MC', baseEur: (mcCents / 100 + MCT + MCCOL + MCSF),
             fixedAddsEur: fixFixedAdds, qf: qf,
             qty: qty, netCents: netCents, grossCents: grossCents });
  }

  function compute() {
    // v15.4: once the "file missing" note was shown, keep it in sync (it hides
    // as soon as a file is chosen or another artwork option is picked).
    if (uploadReqShown) setTimeout(refreshUploadReq, 0);
    if (hasScenarioSetup()) { return computeScenarioPrice(); }
    // v15.3: one decimal (100,5). Empty -> NaN -> "Bitte Maße eingeben", as before.
    var b = readDim($w);
    var h = readDim($h);
    var t = $t ? readDim($t) : 0;
    var qty = getQty();

    // v14.9 — Stoffbanner (Kapitel 5, Wolfgang Stand 08/2026): fixed price per m²,
    // NO country/customer-group/quantity factors at all ("es gibt keine
    // Anpassungsfaktoren"), with a minimum billable area (0.5 m² unless the
    // formula overrides it). No frame, no colour, no fabric CHOICE — this
    // product IS one specific fabric; only the print-data fee is added on top.
    if (CFG.formula && CFG.formula.kind === 'AREA_FIX') {
      var errAF = validate(b, h, t);
      if (errAF) { return fail(errAF); }
      var synthFab = { articleNo: CFG.articleNo, mc: 0, title: '', noPrint: false };
      updateTextileUI(synthFab);
      var Araw = (b * h) / 10000;
      var Afix = Math.max(Araw, CFG.formula.minArea || 0.5);
      // v15.1: tell the customer what the area is, and — while it is under the
      // minimum — why the price is not moving. Display only; see showAreaNote().
      showAreaNote(b, h, Araw, Afix);

      // AREA_FIX / Stoffbanner still supports the same artwork choices as the
      // other printable products: own upload, catalogue motif, or unprinted.
      // The previous AREA_FIX branch hard-coded dsg=null here, so a catalogue
      // selection was visible in the UI but was ignored by pricing/cart data
      // and the print-data fee could remain active. Keep the fixed area price
      // untouched; only feed the existing selectedDesign/selectedPrintData
      // helpers the synthetic always-on Stoffbanner fabric. The base Stoffbanner
      // formula remains area x FP; a selected catalogue motif is an explicit fixed
      // artwork surcharge from its metaobject (e.g. 85 EUR), just as on the other
      // printable product categories. Selecting a catalogue motif suppresses the
      // print-data fee via selectedPrintData(..., dsgAF).
      var dsgAF = selectedDesign(synthFab);
      var pdAF = selectedPrintData(synthFab, dsgAF);
      var fixedAddsAF = (pdAF ? pdAF.price : 0) + (dsgAF ? dsgAF.price : 0);
      var netCentsAF = Math.round((Afix * CFG.formula.fp + fixedAddsAF) * 100);
      var grossCentsAF = Math.round(netCentsAF * (1 + CFG.settings.vat));

      setErr('');
      $quote.style.display = 'none';
      $price.style.display = 'block';
      var adNAF = addonUnitNetCents(qty), adGAF = Math.round(adNAF * (1 + CFG.settings.vat));
      refreshAddonTiles();
      $net.textContent = fmt.format((netCentsAF + adNAF) / 100);
      $gross.textContent = fmt.format((grossCentsAF + adGAF) / 100);
      writeDisplayedTotals(netCentsAF + adNAF, grossCentsAF + adGAF, qty);
      if ($vatNote) $vatNote.textContent = L.vatNote(CFG.settings.vat);
      $line.textContent = L.lineTotal(qty, fmt.format(((grossCentsAF + adGAF) * qty) / 100));
      showAddons(true);
      setSubmitEnabled(true);

      writeProps({
        b: b, h: h, t: null, dim: false, dia: null, exec: null,
        fabric: null, fabricTitle: null, fabric2: null, fabric2Title: null,
        printed: textileOnFn() ? printMode : null,
        color: { code: 'NONE', name: '', isRal: false }, ralCode: null,
        pd: pdAF, dsg: dsgAF, cab: null,
        qty: qty, netCents: netCentsAF, grossCents: grossCentsAF
      });
      pxSnap({ model: 'AREA_FIX', baseEur: null, fixedAddsEur: fixedAddsAF, qf: 1,
               qty: qty, netCents: netCentsAF, grossCents: grossCentsAF });
      return;
    }

    var col = selectedColor();

    if ($colorName) $colorName.textContent = col.name;
    if ($ralWrap) $ralWrap.style.display = col.isRal ? 'block' : 'none';

    updateFabricAvailability(b, h, t);
    var fab = selectedFabric();
    updateTextileUI(fab);

    if (textileOnFn() && $fabricSelect && !fab) return fail(L.errNoFabric);

    var err = validate(b, h, t);
    if (err) { return fail(err); }

    var dim = CFG.formula.dimmingAvailable && $dim && $dim.checked;
    var MCR = computeMCR(b, h, t, dim);
    if (MCR === null) return fail('PX: formula config error for B=' + b);
    if (MCR < 0) MCR = 0;

    var fab2 = selectedFabric2();
    var MCT = computeMCT(fab, fab2, b, h, t);

    // v13.3: colour pricing (client feedback)
    // - RAL: perimeter formula (as before)
    // - colour with use_formula=true (e.g. black/white coating): SAME perimeter formula
    // - other colours: flat surcharge from the metaobject
    // - products with "ralIncluded":true (architects): every colour costs 0
    var colourFormula = ralPerimeterMeters(CFG.formula.ralPerimeter, b, h, t) * CFG.settings.ralRate + CFG.settings.ralFlat;
    var MCCOL = 0;
    if (!CFG.formula.ralIncluded && !col.isRal) {
      MCCOL = col.useFormula ? colourFormula : col.surcharge;
    }
    var MCSF = 0;
    if (col.isRal && !CFG.formula.ralIncluded) {
      MCSF = colourFormula;
    }

    var MC = MCR + MCT + MCCOL + MCSF;

    var qf = qtyFactor(qty);
    if (qf === null) {
      pxSnapNoPrice('FORMULA', MC, qty);
      $price.style.display = 'none';
      clearDisplayedTotals();
      $quote.textContent = L.quoteNote(CFG.settings.qtyThreshold);
      $quote.style.display = 'block';
      setErr('');
      setSubmitEnabled(false);
      clearProps();
      return;
    }

    var dsg = dualUiReady() ? dualCatalogueDesignForPricing() : selectedDesign(fab);
    var pd = dualUiReady() ? dualSelectedPrintData() : selectedPrintData(fab, dsg);
    var catalogueAdds = dualUiReady() ? dualCataloguePriceForPricing() : (dsg ? dsg.price : 0);
    var fixedAdds = (pd ? pd.price : 0) + catalogueAdds;

    var spNet = MC * CFG.factors.cf * CFG.factors.cgf * qf + fixedAdds;
    var netCents = Math.round(spNet * 100);
    var grossCents = Math.round(netCents * (1 + CFG.settings.vat));

    setErr('');
    $quote.style.display = 'none';
    $price.style.display = 'block';
    var adN = addonUnitNetCents(qty), adG = Math.round(adN * (1 + CFG.settings.vat));
    refreshAddonTiles();
    $net.textContent = fmt.format((netCents + adN) / 100);
    $gross.textContent = fmt.format((grossCents + adG) / 100);
    writeDisplayedTotals(netCents + adN, grossCents + adG, qty);
    if ($vatNote) $vatNote.textContent = L.vatNote(CFG.settings.vat);
    $line.textContent = L.lineTotal(qty, fmt.format(((grossCents + adG) * qty) / 100));
    showAddons(true);
    setSubmitEnabled(true);

    writeProps({
      b: b, h: h, t: t, dim: !!dim, dia: null, exec: execLabel(),
      fabric: fab ? fab.articleNo : null, fabricTitle: fab ? fab.title : null,
      fabric2: (CFG.formula.dualFabric && fab2) ? fab2.articleNo : null,
      fabric2Title: (CFG.formula.dualFabric && fab2) ? fab2.title : null,
      printed: textileOnFn() ? printMode : null,
      color: col, ralCode: col.isRal && $ralCode ? $ralCode.value.trim() : null,
      pd: pd, dsg: dsg, cab: selectedCable(),
      qty: qty, netCents: netCents, grossCents: grossCents
    });
    pxSnap({ model: 'FORMULA', baseEur: MC, fixedAddsEur: fixedAdds, qf: qf,
             qty: qty, netCents: netCents, grossCents: grossCents });
  }

  function fail(msg) {
    pxQuote = null;
    hideAreaNote();   // v15.1: the Stoffbanner area line must not survive an invalid entry
    showAddons(false);
    clearDisplayedTotals();
    setErr(msg);
    $price.style.display = 'none';
    $quote.style.display = 'none';
    setSubmitEnabled(false);
    clearProps();
  }

  function setSubmitEnabled(on) {
    if (!submitBtn) return;
    submitBtn.disabled = !on;
    submitBtn.setAttribute('aria-disabled', String(!on));
  }

  // ---------- line item properties ----------
  function setHidden(name, value) {
    if (!form) return;
    var sel = 'input[type="hidden"][name="' + CSS.escape(name) + '"]';
    var els = form.querySelectorAll(sel);
    if (value === null || value === undefined || value === '') {
      els.forEach(function (node) { node.remove(); });
      return;
    }
    var el = els.length ? els[0] : null;
    for (var i = 1; i < els.length; i++) els[i].remove();
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden'; el.name = name;
      form.appendChild(el);
    }
    el.value = value;
  }

  // v14.16: writeProps() is now the ONE shared cart-property writer for EVERY
  // scenario (formula, Stoffbanner, round products) — guarantees identical
  // property order and completeness everywhere. A field that does not apply
  // to a given scenario is simply passed as null; nothing is ever silently
  // "forgotten" in just one code path (this is exactly what caused the cable
  // output to go missing on round products before this version).
  function writeProps(s) {
    ALL_PROP_KEYS.forEach(function (k) { setHidden('properties[' + k + ']', null); });

    setHidden('properties[_calculated_price]', CFG.settings.taxesIncluded ? s.grossCents : s.netCents);
    setHidden('properties[_cfg]', JSON.stringify({
      a: CFG.articleNo, scenario: s.scenario || null, vid: s.vid || null,
      b: s.b || null, h: s.h || null, t: s.t || null, dim: !!s.dim,
      dia: s.dia || null, exec: s.exec || null, prt: s.printed,
      fab: s.fabric, fab2: s.fabric2 || null, col: s.color.code,
      ral: s.color.isRal ? (s.ralCode || 'RAL') : null,
      pd: s.pd ? s.pd.code : null,
      dsg: s.dsg ? s.dsg.code : null,
      modeF: dualUiReady() ? dualSideMode('front') : null,
      modeB: dualUiReady() ? dualSideMode('back') : null,
      dsgF: dualUiReady() ? dualSideDesign('front').code : null,
      dsgB: dualUiReady() ? dualSideDesign('back').code : null,
      cab: s.cab ? s.cab.code : null,
      tier: CFG.factors.tier, cty: CFG.factors.country, qty: s.qty, lang: lang,
      net: s.netCents, gross: s.grossCents, v: CFG.version
    }));
    // v15.0: every key and generated value below is PKEY (German), never L.
    // v15.3: "100,5" (always a comma, like every cart value); whole numbers
    // stay "100" exactly as before.
    setHidden('properties[' + PKEY.pW + ']', s.b ? fmtDimCart(s.b) : null);
    setHidden('properties[' + PKEY.pH + ']', s.h ? fmtDimCart(s.h) : null);
    setHidden('properties[' + PKEY.pT + ']', s.t ? fmtDimCart(s.t) : null);
    setHidden('properties[' + PKEY.pDia + ']', s.dia || null);
    setHidden('properties[' + PKEY.pDim + ']', s.dim ? PKEY.yes : null);
    setHidden('properties[' + PKEY.pExec + ']', s.exec || null);
    if (s.fabric2) {
      setHidden('properties[' + PKEY.pFabF + ']', s.fabricTitle + ' (' + s.fabric + ')');
      setHidden('properties[' + PKEY.pFabB + ']', s.fabric2Title + ' (' + s.fabric2 + ')');
    } else {
      setHidden('properties[' + PKEY.pFab + ']', s.fabric ? (s.fabricTitle + ' (' + s.fabric + ')') : null);
    }
    // dualFabric v14.40: production/cart data is also independent per side.
    // Reuse the same stable property naming already used by Messesystem slots.
    if (dualUiReady()) {
      ['de', 'en'].forEach(function (lg) {
        for (var ds = 1; ds <= 2; ds++) {
          setHidden('properties[' + hwDesignPropName(lg, ds) + ']', null);
          setHidden('properties[' + hwMotifPropName(lg, ds) + ']', null);
        }
      });
      ['front', 'back'].forEach(function (side, idx) {
        var mode = dualSideMode(side);
        var design = dualSideDesign(side);
        setHidden('properties[' + hwDesignPropName('de', idx + 1) + ']', hwModeText(mode, 'de'));
        setHidden('properties[' + hwMotifPropName('de', idx + 1) + ']', mode === 'catalog' && design.name ? design.name : null);
      });
      // Do not write misleading global Druck/Bildmotiv values for a mixed
      // front/back configuration; the two explicit side properties above win.
      setHidden('properties[' + PKEY.pPrint + ']', null);
      setHidden('properties[' + PKEY.pDsg + ']', null);
    } else {
      // Normal textile products have a fabric id. AREA_FIX Stoffbanner products
      // intentionally do not: the product itself IS the fabric. Still expose the
      // customer's print choice in the cart for AREA_FIX only.
      var canWritePrint = !!(s.printed && (s.fabric || (CFG.formula && CFG.formula.kind === 'AREA_FIX')));
      setHidden('properties[' + PKEY.pPrint + ']', canWritePrint ? (s.printed === 'YES' ? PKEY.printWith : PKEY.printWithout) : null);
      setHidden('properties[' + PKEY.pDsg + ']', s.dsg ? s.dsg.name : null);
    }
    setHidden('properties[' + PKEY.pPd + ']', s.pd ? s.pd.name : null);
    setHidden('properties[' + PKEY.pCab + ']', s.cab ? s.cab.name : null);
    // v14.16: whether colour applies is decided by whether the colour section
    // actually rendered ($colorName exists) — this is universally correct for
    // BOTH colorsDisabled formula products AND round products with no colour
    // linked, replacing the old formula-only "CFG.formula.colorsDisabled" check.
    if (!$colorName) {
      // no colour section on this product at all — nothing to write
    } else if (s.color.isRal) {
      setHidden('properties[' + PKEY.pRal + ']', s.ralCode || PKEY.yes);
    } else {
      setHidden('properties[' + PKEY.pCol + ']', s.color.name);
    }
  }

  function clearProps() {
    ['_calculated_price', '_cfg'].forEach(function (k) { setHidden('properties[' + k + ']', null); });
    ALL_PROP_KEYS.forEach(function (k) { setHidden('properties[' + k + ']', null); });
    clearHwDynamicFabricProps();
  }

  // ---------- events ----------
  var deb;
  function schedule() { clearTimeout(deb); deb = setTimeout(compute, 150); }

  // Card UIs create some per-textile hidden state AFTER this core file has loaded.
  // Listen to one explicit pricing-refresh event so catalogue/mode changes always
  // recompute the authoritative product price, even when the underlying native
  // radio/button was already in the same global state.
  root.addEventListener('px:pricing-change', schedule);
  // Dynamic textile-card controls are created after this file loads. Listen at
  // the configurator root as a second safety net, so any card state mutation
  // always reaches the price engine even if a specific hidden input had no
  // direct listener at initialization time.
  root.addEventListener('px:textile-preview-change', schedule);
  root.addEventListener('change', function (e) {
    var el = e && e.target;
    if (!el || !el.classList) return;
    if (el.classList.contains('px-hw-design-mode') ||
        el.classList.contains('px-hw-design-code') ||
        el.classList.contains('px-hw-design-name') ||
        el.classList.contains('px-hw-design-image') ||
        el.classList.contains('px-hw-design-price') ||
        el.classList.contains('px-dual-design-mode') ||
        el.classList.contains('px-dual-design-code') ||
        el.classList.contains('px-dual-design-name') ||
        el.classList.contains('px-dual-design-image') ||
        el.classList.contains('px-dual-design-price')) {
      schedule();
    }
  });

  root.querySelectorAll('.px-stepper button[data-target]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById(btn.dataset.target);
      if (!input) return;
      // v15.3: keeps the decimal (100,5 + 1 = 101,5). min/max are read from the
      // attributes, which stay on the field after it became type=text.
      var v = readDim(input);
      var min = parseFloat(input.getAttribute('min'));
      var max = parseFloat(input.getAttribute('max'));
      if (!isFinite(v) || v <= 0) v = isFinite(min) ? min : 0;
      v = round1(v + parseInt(btn.dataset.step, 10));
      if (isFinite(min) && v < min) v = min;
      if (isFinite(max) && v > max) v = max;
      input.value = fmtDimDisplay(v);
      schedule();
    });
  });

  function execLabel() {
    // v15.0: the return value becomes properties[Ausführung] and _cfg.exec, so
    // it is a CART VALUE and therefore always German (PKEY).
    //
    // For fabricModes products the label comes from the Formula JSON. It used to
    // be read from the button's VISIBLE text, which both Weglot (on /fr/) and
    // the re-skin layer in primex-ui-enhancements.js rewrite — so production
    // could receive a translated or relabelled value. Read the untranslated
    // sources in order of trust instead.
    var active = root.querySelector('.px-exec-btn.px-active');
    if (!active) return PKEY.withT;
    if (active.dataset.mode === 'NONE') return PKEY.withoutT;
    if (active.dataset.mode === 'WITH') return PKEY.withT;
    return (active.dataset.label || '').trim() ||
           (active.dataset.pxOriginalExecLabel || '').trim() ||
           active.textContent.trim();
  }
  $execBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      execMode = btn.dataset.mode;
      $execBtns.forEach(function (b) { b.classList.toggle('px-active', b === btn); });
      schedule();
    });
  });

  // v13: Mit Druck / Ohne Druck (client point 2)
  $printBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      printMode = btn.dataset.print;
      $printBtns.forEach(function (b) { b.classList.toggle('px-active', b === btn); });
      schedule();
    });
  });

  [$w, $h, $t].forEach(function (el) { el && el.addEventListener('input', schedule); });
  if ($dim) $dim.addEventListener('change', schedule);
  if ($ralCode) $ralCode.addEventListener('input', schedule);
  if ($fabricSelect) $fabricSelect.addEventListener('change', schedule);
  if ($fabricSelect2) $fabricSelect2.addEventListener('change', schedule);
  if ($pdSelect) $pdSelect.addEventListener('change', schedule);
  if ($cableSelect) $cableSelect.addEventListener('change', function () {
    updateCableSvgActive();
    schedule();
  });

  root.querySelectorAll('input[name="px-fcolor"]').forEach(function (r) {
    r.addEventListener('change', schedule);
  });

  // design catalogue
  if ($designToggle) $designToggle.addEventListener('change', schedule);
  if ($designCatalog) $designCatalog.addEventListener('change', function () {
    root.querySelectorAll('.px-design-panel').forEach(function (p) {
      p.classList.toggle('px-active-panel', p.dataset.catalog === $designCatalog.value);
    });
    schedule();
  });
  root.querySelectorAll('.px-design-panel input[type="radio"]').forEach(function (r) {
    r.addEventListener('change', schedule);
  });
  root.querySelectorAll('.px-dtile .px-dimg').forEach(function (img) {
    img.addEventListener('click', function () {
      var radio = img.closest('.px-dtile').querySelector('input[type="radio"]');
      if (radio && !radio.checked) { radio.checked = true; schedule(); }
      if (img.dataset.full) openLightbox(img.dataset.full);
    });
  });

  // ---------- v13 upload: Drag & Drop zone (client design; fixes v12 click bug) ----------
  function uploadInputs() {
    return Array.prototype.slice.call(root.querySelectorAll('.px-upinput'));
  }
  function anyFiles() {
    return uploadInputs().some(function (inp) { return inp.files && inp.files.length; });
  }
  function clearAllFiles() {
    uploadInputs().forEach(function (inp) { inp.value = ''; });
    refreshUploadList();
  }
  // v14.1: each fabric side has its OWN upload zone (front + back on dualFabric
  // products). Every wrap is wired independently: its dropzone fills its own
  // slots only, and shows its own file list.
  function wrapInputs(w) {
    return Array.prototype.slice.call(w.querySelectorAll('.px-upinput'));
  }
  function refreshWrapList(w) {
    var lst = w.querySelector('.px-uplist');
    if (!lst) return;
    lst.innerHTML = '';
    wrapInputs(w).forEach(function (inp) {
      if (!inp.files || !inp.files.length) return;
      var row = document.createElement('div');
      row.className = 'px-uprow';
      var name = document.createElement('span');
      name.textContent = inp.files[0].name;
      var del = document.createElement('button');
      del.type = 'button';
      del.textContent = '✕';
      del.setAttribute('aria-label', 'remove');
      del.addEventListener('click', function () {
        inp.value = '';
        refreshWrapList(w);
        schedule();
      });
      row.appendChild(name); row.appendChild(del);
      lst.appendChild(row);
    });
  }
  function refreshUploadList() {
    $pfUpWraps.forEach(refreshWrapList);
  }
  $pfUpWraps.forEach(function (w) {
    var dz = w.querySelector('.px-dropzone');
    function nextEmptyInWrap() {
      var inputs = wrapInputs(w);
      for (var i = 0; i < inputs.length; i++) {
        if (!inputs[i].files || !inputs[i].files.length) return inputs[i];
      }
      return null;
    }
    function assignToWrap(fileList) {
      var assigned = false;
      Array.prototype.forEach.call(fileList, function (file) {
        var inp = nextEmptyInWrap();
        if (!inp) return;
        var dt = new DataTransfer();
        dt.items.add(file);
        inp.files = dt.files;
        assigned = true;
      });
      if (assigned) {
        if ($designToggle && $designToggle.checked) $designToggle.checked = false; // exclusivity
        refreshWrapList(w);
        schedule();
      }
    }
    if (dz) {
      dz.addEventListener('click', function () {
        var inp = nextEmptyInWrap();
        if (inp) inp.click();
      });
      dz.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); dz.click(); }
      });
      ['dragenter', 'dragover'].forEach(function (ev) {
        dz.addEventListener(ev, function (e) {
          e.preventDefault(); e.stopPropagation();
          dz.classList.add('px-dragover');
        });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        dz.addEventListener(ev, function (e) {
          e.preventDefault(); e.stopPropagation();
          dz.classList.remove('px-dragover');
        });
      });
      dz.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
          assignToWrap(e.dataTransfer.files);
        }
      });
    }
    wrapInputs(w).forEach(function (inp) {
      inp.addEventListener('change', function () {
        if (inp.files && inp.files.length && $designToggle && $designToggle.checked) {
          $designToggle.checked = false; // file chosen -> catalogue off (one option at a time)
        }
        refreshWrapList(w);
        schedule();
      });
    });
  });
  refreshUploadList();

  // ---------- v14.0: Handelsware textile UI wiring ----------
  function hwUpdateSlots() {
    if (!$hwWrap) return;
    $hwWrap.querySelectorAll('.px-hw-slot').forEach(function (slot) {
      var i = parseInt(slot.dataset.slot, 10);
      slot.style.display = (i <= hwCount) ? 'block' : 'none';
      var info = slot.querySelector('.px-hw-info');
      var sel = slot.querySelector('.px-hw-fabric');

      // Apply the same normal/rotated fit logic to Messesystem textile slots.
      // If the selected variant title contains e.g. "100 x 200 cm", those
      // dimensions are the physical textile rectangle for this availability check.
      // Slots whose physical dimensions cannot be derived are left unchanged.
      if (sel && i <= hwCount) {
        var hwDims = hwVariantDims();
        if (hwDims) {
          applyFabricAvailabilityToSelect(
            sel,
            [{ width: hwDims.b, height: hwDims.h }],
            false
          );
        }
      }

      if (info && sel) {
        var opt = sel.options[sel.selectedIndex];
        var txt = opt ? (tooltipFor(opt.dataset.title || opt.text) || opt.dataset.info) : null;
        if (i <= hwCount && txt) { info.textContent = txt; info.style.display = 'block'; }
        else { info.style.display = 'none'; }
      }

      // Files are valid only for active slots using "Eigene Datei". Clearing
      // them here guarantees catalogue/unprinted slots can never leak an old
      // upload into FormData or the live preview.
      if (i > hwCount || hwSlotMode(i) !== 'upload') {
        var inp = $hwWrap.querySelector('.px-hw-upinput[data-slot="' + i + '"]');
        if (inp && inp.files && inp.files.length) { inp.value = ''; }
        var lst = $hwWrap.querySelector('.px-hw-uplist[data-slot="' + i + '"]');
        if (lst) lst.innerHTML = '';
      }
    });
    if ($hwPd) $hwPd.style.display = (hwCount > 0 && hwAnyOwnUpload()) ? 'block' : 'none';
  }
  if ($hwWrap) {
    $hwModeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        hwCount = parseInt(btn.dataset.count, 10) || 0;
        $hwModeBtns.forEach(function (b) { b.classList.toggle('px-active', b === btn); });
        hwUpdateSlots();
        schedule();
      });
    });
    $hwWrap.querySelectorAll('.px-hw-fabric').forEach(function (sel) {
      sel.addEventListener('change', function () { hwUpdateSlots(); schedule(); });
    });
    $hwWrap.querySelectorAll('.px-hw-design-mode, .px-hw-design-code, .px-hw-design-name, .px-hw-design-image, .px-hw-design-price').forEach(function (state) {
      state.addEventListener('change', function () {
        if (state.classList.contains('px-hw-design-mode')) hwUpdateSlots();
        schedule();
      });
    });
    if ($hwPdSelect) $hwPdSelect.addEventListener('change', schedule);
    $hwWrap.querySelectorAll('.px-hw-drop').forEach(function (dz) {
      var slot = dz.dataset.slot;
      var inp = $hwWrap.querySelector('.px-hw-upinput[data-slot="' + slot + '"]');
      var lst = $hwWrap.querySelector('.px-hw-uplist[data-slot="' + slot + '"]');
      function renderList() {
        if (!lst) return;
        lst.innerHTML = '';
        if (inp && inp.files && inp.files.length) {
          var row = document.createElement('div');
          row.className = 'px-uprow';
          var name = document.createElement('span');
          name.textContent = inp.files[0].name;
          var del = document.createElement('button');
          del.type = 'button'; del.textContent = '✕';
          del.addEventListener('click', function () { inp.value = ''; renderList(); schedule(); });
          row.appendChild(name); row.appendChild(del);
          lst.appendChild(row);
        }
      }
      if (dz && inp) {
        dz.addEventListener('click', function () { inp.click(); });
        dz.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); inp.click(); }
        });
        ['dragenter','dragover'].forEach(function (ev) {
          dz.addEventListener(ev, function (e) { e.preventDefault(); e.stopPropagation(); dz.classList.add('px-dragover'); });
        });
        ['dragleave','drop'].forEach(function (ev) {
          dz.addEventListener(ev, function (e) { e.preventDefault(); e.stopPropagation(); dz.classList.remove('px-dragover'); });
        });
        dz.addEventListener('drop', function (e) {
          if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
            var dt = new DataTransfer();
            dt.items.add(e.dataTransfer.files[0]);
            inp.files = dt.files;
            renderList(); schedule();
          }
        });
        inp.addEventListener('change', function () { renderList(); schedule(); });
      }
    });
    hwUpdateSlots();
  }

  // ---------- v13.2: inline interactive SVG cable diagram ----------
  // Drawn by us (frame + numbered circles + plug), so it scales perfectly on
  // every device — no image-overlay alignment problems. Positions come from
  // CFG.cableHotspots percentages; the SVG canvas is 1314 x 1197 units.
  var SVGNS = 'http://www.w3.org/2000/svg';
  function svgEl(tag, attrs, parent) {
    var el = document.createElementNS(SVGNS, tag);
    for (var k in attrs) el.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(el);
    return el;
  }
  function updateCableSvgActive() {
    if (!$cableSvgWrap || !$cableSelect) return;
    var cur = $cableSelect.value;
    $cableSvgWrap.querySelectorAll('.px-cs-hit').forEach(function (g) {
      g.classList.toggle('px-cs-active', g.getAttribute('data-val') === cur);
    });
    // v14.25: round LED products (circle_square) — the plug+cable icon follows
    // whichever position is currently selected, instead of sitting fixed on one.
    $cableSvgWrap.querySelectorAll('.px-cs-plug').forEach(function (g) {
      g.style.display = (g.getAttribute('data-val') === cur) ? '' : 'none';
    });
  }
  function buildCableSvg() {
    if (!$cableSvgWrap || !$cableSelect) return false;
    var spots = CFG.cableHotspots;
    if (!spots) return false;
    // v13.6.1: if the liquid rendered an empty dropdown (positions field missing),
    // build the options from the hotspot numbers so the section still works
    if ($cableSelect.options.length === 0) {
      Object.keys(spots).filter(function (k) { return k !== 'shape'; })
        .sort(function (a, b) { return a - b; })
        .forEach(function (k, i) {
          var o = document.createElement('option');
          o.value = k; o.textContent = k; if (i === 0) o.selected = true;
          $cableSelect.appendChild(o);
        });
    }
    var W = 1314, H = 1197;
    var svg = svgEl('svg', { viewBox: '0 0 ' + W + ' ' + H, 'class': 'px-cablesvg', role: 'group' });
    svg.setAttribute('aria-label', L.cableLabel);
    // v13.6: frame shape from hotspots JSON "shape" key — 'rectangle' (default) / 'square' / 'circle' / 'circle_square'
    var shape = spots.shape === 'circle' ? 'circle'
      : spots.shape === 'square' ? 'square'
      : spots.shape === 'circle_square' ? 'circle_square'
      : 'rect';
    if (shape === 'circle' || shape === 'circle_square') {
      svgEl('circle', { cx: 571, cy: 569, r: 490, fill: 'none',
                        stroke: '#58585a', 'stroke-width': 16 }, svg);
    } else if (shape === 'square') {
      svgEl('rect', { x: 167, y: 79, width: 980, height: 980, rx: 10, fill: 'none',
                      stroke: '#58585a', 'stroke-width': 16 }, svg);
    } else {
      svgEl('rect', { x: 84, y: 79, width: 974, height: 980, rx: 10, fill: 'none',
                      stroke: '#58585a', 'stroke-width': 16 }, svg);
    }
    // v14.23: round LED products (Wolfgang) — an inner square drawn inside the
    // circle, representing the mounting panel; only 2 hotspots normally used
    // with this shape, positioned on/near this inner square.
    if (shape === 'circle_square') {
      svgEl('rect', { x: 281, y: 279, width: 580, height: 580, rx: 6, fill: 'none',
                      stroke: '#58585a', 'stroke-width': 10 }, svg);
    }
    // plug icon bottom right: cable starts at position 5 (ring point differs per shape)
    // v14.24: circle_square does NOT use this large external plug at all — see below,
    // it gets a small plug drawn directly next to hotspot 1, inside the square.
    var cableD = shape === 'circle'
      ? 'M 866 960 C 1000 1130 1180 1120 1186 1010 L 1186 992'
      : shape === 'square'
        ? 'M 1030 1060 C 1100 1160 1180 1130 1186 1010 L 1186 992'
        : 'M 950 1060 C 1060 1165 1180 1140 1186 1010 L 1186 992';
    if (shape !== 'circle_square') {
      var plug = svgEl('g', { fill: 'none', stroke: '#58585a' }, svg);
      svgEl('path', { d: cableD, 'stroke-width': 30, 'stroke-linecap': 'round' }, plug);
      svgEl('path', { d: cableD, 'stroke-width': 12, stroke: '#ffffff', 'stroke-linecap': 'round' }, plug);
      svgEl('path', { d: 'M 1152 992 h 68 v -58 q 0 -16 -16 -20 h -36 q -16 4 -16 20 z',
                      fill: '#fdf8f6', 'stroke-width': 12, 'stroke-linejoin': 'round' }, plug);
      svgEl('rect', { x: 1163, y: 862, width: 11, height: 52, fill: '#58585a', stroke: 'none' }, plug);
      svgEl('rect', { x: 1198, y: 862, width: 11, height: 52, fill: '#58585a', stroke: 'none' }, plug);
    } else {
      // v14.25: round LED products — one plug+cable icon PER hotspot, computed
      // from that hotspot's own real position (not hardcoded), so it always
      // stays correctly attached even if the coordinates are nudged later.
      // Only the plug matching the CURRENTLY SELECTED position is shown —
      // updateCableSvgActive() toggles this every time the customer clicks a
      // different position. Bigger than the first attempt, per feedback.
      Object.keys(spots).filter(function (k) { return k !== 'shape'; }).forEach(function (val) {
        var pos = spots[val];
        if (!pos || pos.length < 2) return;
        var px = pos[0] * W / 100, py = pos[1] * H / 100;
        var bx = px + 65, by = py - 120; // plug body offset: how far right/up from the dot — see note below on adjusting this
        var miniPlug = svgEl('g', { 'class': 'px-cs-plug', 'data-val': val,
                                     fill: 'none', stroke: '#58585a',
                                     style: 'display:none' }, svg);
        var curlD = 'M ' + (bx + 5) + ' ' + (by + 38) + ' C ' + (bx - 25) + ' ' + (by + 55) + ' ' + (px - 8) + ' ' + (py - 20) + ' ' + px + ' ' + py;
        svgEl('path', { d: curlD, 'stroke-width': 14, 'stroke-linecap': 'round' }, miniPlug);
        svgEl('path', { d: curlD, 'stroke-width': 6, stroke: '#ffffff', 'stroke-linecap': 'round' }, miniPlug);
        svgEl('rect', { x: bx, y: by, width: 66, height: 46, rx: 7, fill: '#fdf8f6',
                        'stroke-width': 7, 'stroke-linejoin': 'round' }, miniPlug);
        svgEl('rect', { x: bx + 16, y: by - 22, width: 10, height: 26, fill: '#58585a', stroke: 'none' }, miniPlug);
        svgEl('rect', { x: bx + 40, y: by - 22, width: 10, height: 26, fill: '#58585a', stroke: 'none' }, miniPlug);
      });
    }
    // numbered, clickable circles
    for (var i = 0; i < $cableSelect.options.length; i++) {
      (function (val) {
        var pos = spots[val];
        if (!pos || pos.length < 2) return;
        var cx = pos[0] * W / 100, cy = pos[1] * H / 100;
        var g = svgEl('g', { 'class': 'px-cs-hit', 'data-val': val, tabindex: '0', role: 'button' }, svg);
        g.setAttribute('aria-label', L.pos(val));
        svgEl('circle', { cx: cx, cy: cy, r: 62, 'class': 'px-cs-ring' }, g);
        svgEl('circle', { cx: cx, cy: cy, r: 46, fill: '#58585a', 'class': 'px-cs-dot' }, g);
        var t = svgEl('text', { x: cx, y: cy, 'class': 'px-cs-num',
                                'text-anchor': 'middle', 'dominant-baseline': 'central' }, g);
        t.textContent = val;
        function choose() {
          $cableSelect.value = val;
          $cableSelect.dispatchEvent(new Event('change', { bubbles: true }));
          updateCableSvgActive();
        }
        g.addEventListener('click', choose);
        g.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(); }
        });
      })($cableSelect.options[i].value);
    }
    $cableSvgWrap.appendChild(svg);
    updateCableSvgActive();
    if ($cableDiagram) $cableDiagram.style.display = 'none'; // metaobject image not needed
    return true;
  }
  var cableSvgActive = buildCableSvg();

  // ---------- lightbox (centered, scroll-locked) ----------
  function openLightbox(src) {
    if ($lightbox && $lightboxImg) {
      $lightboxImg.src = src;
      if ($lightboxHotspots) $lightboxHotspots.innerHTML = '';
      $lightbox.classList.add('px-open');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeLightbox() {
    if ($lightbox) $lightbox.classList.remove('px-open');
    if ($lightboxImg) $lightboxImg.src = '';
    if (!$infoModal || !$infoModal.classList.contains('px-open')) document.body.style.overflow = '';
  }
  if ($cableDiagram && !cableSvgActive) $cableDiagram.addEventListener('click', function () {
    openLightbox($cableDiagram.dataset.full);
  });
  if ($lightboxClose) $lightboxClose.addEventListener('click', closeLightbox);
  if ($lightbox) $lightbox.addEventListener('click', function (e) {
    if (e.target === $lightbox) closeLightbox();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeLightbox(); closeInfoModal(); }
  });

  // ---------- v14.4: fabric-info popup (centered, scroll-locked, same pattern as lightbox) ----------
  // One icon per textile dropdown (works for 1 up to 6 slots alike); clicking it lists
  // EVERY fabric offered in THAT dropdown (name + tooltip text), not just the selected one.
  function escapeHtmlPx(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function openInfoModal(selectId) {
    var sel = document.getElementById(selectId);
    if (!sel || !$infoModal || !$infoModalBody) return;
    // modal now lives outside the configurator's own container (to escape a fixed
    // ancestor), so its title is set here on every open rather than by applyLang()
    if ($infoModalTitle) $infoModalTitle.textContent = L.infoModalTitle;
    var html = '';
    Array.prototype.forEach.call(sel.options, function (opt) {
      var title = opt.dataset.title || opt.text;
      var info = tooltipFor(title) || opt.dataset.info || '';
      html += '<div class="px-info-fab"><b>' + escapeHtmlPx(title) + '</b>' + (info ? escapeHtmlPx(info) : '') + '</div>';
    });
    $infoModalBody.innerHTML = html;
    $infoModal.classList.add('px-open');
    document.body.style.overflow = 'hidden';
  }
  function closeInfoModal() {
    if ($infoModal) $infoModal.classList.remove('px-open');
    if (!$lightbox || !$lightbox.classList.contains('px-open')) document.body.style.overflow = '';
  }
  root.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.px-info-btn');
    if (btn) { e.preventDefault(); openInfoModal(btn.dataset.for); }
  });
  if ($infoModalClose) $infoModalClose.addEventListener('click', closeInfoModal);
  if ($infoModal) $infoModal.addEventListener('click', function (e) {
    if (e.target === $infoModal) closeInfoModal();
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'quantity') schedule();
    else if (hasScenarioSetup()) schedule();
  });
  document.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'quantity') schedule();
  });

  /* ---------- v14.41: show the cart after add-to-cart, without a reload -------
     This block only decides WHERE the response of /cart/add.js is rendered.
     It never reads or writes a cart property, never re-prices anything and
     never dispatches a 'change' or 'input' event — this file recomputes on any
     document 'change', so a wrong event here would loop the pricing engine. */

  function pxCartHost() {
    return document.querySelector('cart-drawer') ||
           document.querySelector('cart-notification') ||
           null;
  }

  function pxCartDrawerEl() {
    return pxCartHost() ||
           document.getElementById('CartDrawer') ||
           document.querySelector('.cart-drawer, .drawer--cart, #cart-drawer, [data-cart-drawer]') ||
           null;
  }

  // Ask Shopify for exactly the sections THIS theme re-renders after an add.
  // Falling back to the Dawn names keeps the previous behaviour identical.
  function pxSectionsToRequest() {
    var host = pxCartHost();
    try {
      if (host && typeof host.getSectionsToRender === 'function') {
        var ids = host.getSectionsToRender()
          .map(function (sec) { return sec && (sec.section || sec.id); })
          .filter(Boolean);
        if (ids.length) return ids.join(',');
      }
    } catch (e) { /* fall through to the Dawn defaults */ }
    return 'cart-drawer,cart-icon-bubble';
  }

  // Last-resort renderer for themes whose drawer has no renderContents().
  function pxSwapSections(data) {
    if (!data || !data.sections) return false;
    var done = false;
    Object.keys(data.sections).forEach(function (key) {
      var html = data.sections[key];
      if (!html) return;
      var host = document.getElementById(key) ||
                 document.getElementById('shopify-section-' + key);
      if (!host) return;
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(key) ||
                    doc.getElementById('shopify-section-' + key) ||
                    doc.body;
        if (fresh) { host.innerHTML = fresh.innerHTML; done = true; }
      } catch (e) { /* leave this section as it was */ }
    });
    return done;
  }

  // Custom event names ONLY. Never 'change', never 'input'.
  function pxPublishCartUpdate(data) {
    try {
      if (typeof window.publish === 'function' &&
          window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate,
                       { source: 'px-configurator', cartData: data });
      }
    } catch (e) {}
    ['cart:refresh', 'cart:updated'].forEach(function (name) {
      try {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: data } }));
      } catch (e) {}
    });
  }

  // v15.1: this used to be declared INSIDE pxForceOpen(), so it was scoped to
  // that function and the call from pxShowCartAfterAdd() threw ReferenceError.
  // The exception propagated out of pxOpenCartOrReload() into the fetch
  // .catch(), which forced window.location.reload() on EVERY add-to-cart that
  // carried an upload or an add-on. It is a sibling function now.
  function pxClearEmptyState() {
    var el = pxCartDrawerEl();
    if (!el) return;
    try { el.classList.remove('is-empty'); } catch (e) {}
    try {
      var items = el.querySelector('cart-drawer-items');
      if (items) items.classList.remove('is-empty');
    } catch (e) {}
    try {
      var inner = el.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
    } catch (e) {}
  }

  function pxForceOpen(el) {
    if (!el) return false;
    try { if (typeof el.open === 'function') { el.open(); return true; } } catch (e) {}
    try { if (typeof el.show === 'function') { el.show(); return true; } } catch (e) {}
    return false;
  }

  // Most themes open their drawer from the header cart icon, so clicking it is
  // a reliable route that needs no knowledge of the theme's internals.
  function pxClickCartIcon() {
    var a = document.getElementById('cart-icon-bubble') ||
            document.querySelector('a#cart-icon-bubble, #cart-icon-bubble a') ||
            document.querySelector('a[href$="/cart"]');
    if (!a) return false;
    try { a.click(); return true; } catch (e) { return false; }
  }

  // true = the cart was shown without leaving the page.
  function pxShowCartAfterAdd(data) {
    // Must run BEFORE renderContents, or the fresh markup inherits the class.
    pxClearEmptyState();
    var host = pxCartHost();
    if (host && data && data.sections && typeof host.renderContents === 'function') {
      try {
        host.renderContents(data);
        pxForceOpen(host);
        return true;
      } catch (err) {
        console.warn('PX: renderContents failed, using the generic drawer path', err);
      }
    }
    var swapped = pxSwapSections(data);
    pxPublishCartUpdate(data);
    if (pxForceOpen(pxCartDrawerEl())) return true;
    if (pxClickCartIcon()) return true;
    return swapped;
  }

  function pxOpenCartOrReload(data) {
    if (pxShowCartAfterAdd(data)) return;
    console.warn('PX: no cart drawer found on this page — reloading instead');
    try { sessionStorage.setItem('px-open-drawer', '1'); } catch (e) {}
    window.location.reload();
  }

  /* ------------------------------------------------------------------
     v15.4 — MANDATORY file for "Eigene Datei".

     missingUploads() lists every place that is set to "Eigene Datei" but has
     no file. Each entry: { host, dropzone, slot?, side? }. Gating only — no
     price, no property, no _cfg key is read or written here.
  ------------------------------------------------------------------ */
  var uploadReqShown = false;

  function inputsHaveFile(scope, selector) {
    if (!scope) return false;
    var inputs = scope.querySelectorAll(selector);
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].files && inputs[i].files.length) return true;
    }
    return false;
  }

  function missingUploads() {
    var out = [];

    // Messesystem / Handelsware: one check per ACTIVE textile card.
    if ($hwWrap) {
      for (var i = 1; i <= hwCount; i++) {
        if (hwSlotMode(i) !== 'upload') continue;
        var slot = $hwWrap.querySelector('.px-hw-slot[data-slot="' + i + '"]');
        if (!slot || !slot.querySelector('.px-hw-upinput')) continue;   // no upload field
        if (inputsHaveFile(slot, '.px-hw-upinput')) continue;
        out.push({ slot: i, host: null, dropzone: null });
      }
      return out;
    }

    if (!textileOnFn() || printMode !== 'YES') return out;

    // dualFabric: one check per SIDE.
    if (dualUiReady()) {
      ['front', 'back'].forEach(function (side) {
        if (dualSideMode(side) !== 'upload') return;
        var w = $textileSection.querySelector('.px-upload-wrap[data-side="' + side + '"]');
        if (!w || !w.querySelector('.px-upinput')) return;
        if (inputsHaveFile(w, '.px-upinput')) return;
        out.push({ side: side, host: w, dropzone: w.querySelector('.px-dropzone') });
      });
      return out;
    }

    // Normal formula / Stoffbanner / round products.
    if (!$pfUpWraps.length) return out;
    if ($designToggle && $designToggle.checked) return out;   // Katalogmotiv
    var fab = (CFG.formula && CFG.formula.kind === 'AREA_FIX')
      ? { articleNo: CFG.articleNo, mc: 0, title: '', noPrint: false }
      : selectedFabric();
    if (!printedFn(fab)) return out;                          // e.g. no_print fabric
    $pfUpWraps.forEach(function (w) {
      if (!w.querySelector('.px-upinput')) return;
      if (inputsHaveFile(w, '.px-upinput')) return;
      out.push({ host: w, dropzone: w.querySelector('.px-dropzone') });
    });
    return out;
  }

  function uploadNoteEl(host) {
    if (!host) return null;
    var el = host.querySelector(':scope > .px-upload-req');
    if (!el) {
      el = document.createElement('div');
      el.className = 'px-upload-req';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'display:none;margin-top:8px;padding:8px 10px;' +
        'font-size:12.5px;line-height:1.45;color:#b3261e;' +
        'background:#fdf3f2;border:1px solid #f3cfcb;';
      host.appendChild(el);
    }
    return el;
  }

  // Removes every note and red dropzone border this feature added.
  function clearUploadReq() {
    document.querySelectorAll('.px-upload-req').forEach(function (el) { el.style.display = 'none'; });
    document.querySelectorAll('[data-px-upload-flag]').forEach(function (dz) {
      dz.style.borderColor = '';
      dz.removeAttribute('data-px-upload-flag');
    });
  }

  function markDropzone(dz) {
    if (!dz) return;
    dz.style.borderColor = '#b3261e';
    dz.setAttribute('data-px-upload-flag', '1');
  }

  // Card UIs: the visible upload editor is shared between cards, so the card
  // script is asked to switch to the card that is missing its file first.
  function focusCardFor(item) {
    try {
      root.dispatchEvent(new CustomEvent('px:upload-required', {
        bubbles: true,
        detail: { slot: item.slot || null, side: item.side || null }
      }));
    } catch (e) { /* old browsers: the note is still shown */ }
  }

  function hostFor(item) {
    if (item.host) return item.host;
    // Messesystem cards (primex-textile-cards.js): one shared upload editor.
    var editor = $hwWrap ? $hwWrap.querySelector('.pxhw-upload-editor') : null;
    if (editor && !editor.hidden) return editor;
    var slot = $hwWrap ? $hwWrap.querySelector('.px-hw-slot[data-slot="' + item.slot + '"]') : null;
    return slot ? (slot.querySelector('.px-hw-upwrap') || slot) : null;
  }

  // "Stoffbanner 2 – hinten: Bitte laden Sie …" — names the card or side when
  // there is more than one place to upload to.
  function uploadNoteText(item) {
    var prefix = '';
    if (item.slot && $hwWrap) {
      var s = $hwWrap.querySelector('.px-hw-slot[data-slot="' + item.slot + '"]');
      var lbl = s ? String(s.dataset.label || '').trim() : '';
      prefix = (lbl && lbl.toLowerCase() !== 'stoffbanner' ? lbl : (L.textilePrinting + ' ' + item.slot)) + ': ';
    } else if (item.side) {
      prefix = (item.side === 'back' ? L.sideBack : L.sideFront).replace(/[()]/g, '') + ': ';
    }
    return prefix + L.uploadRequired;
  }

  // Shows the note on the FIRST missing place and scrolls there.
  function flagUploadMissing(list) {
    clearUploadReq();
    var first = list[0];
    if (!first) return;
    if (first.slot || first.side) focusCardFor(first);
    var host = hostFor(first);
    var note = uploadNoteEl(host);
    if (note) {
      note.textContent = uploadNoteText(first);
      note.style.display = 'block';
    }
    markDropzone(first.dropzone || (host && host.querySelector('.pxhw-dropzone, .px-dropzone')));
    uploadReqShown = true;
    var target = (host && host.offsetParent !== null) ? host : (note || host);
    try { if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  }

  // After the note was shown once: hide it when solved, move it if needed.
  function refreshUploadReq() {
    if (!uploadReqShown) return;
    var list = missingUploads();
    if (!list.length) { clearUploadReq(); uploadReqShown = false; return; }
    // Still missing: keep a note on the first open place, without scrolling.
    clearUploadReq();
    var host = hostFor(list[0]);
    var note = uploadNoteEl(host);
    if (note) {
      note.textContent = uploadNoteText(list[0]);
      note.style.display = 'block';
    }
    markDropzone(list[0].dropzone || (host && host.querySelector('.pxhw-dropzone, .px-dropzone')));
  }

  // A chosen file must clear the note at once, not after the compute debounce.
  root.addEventListener('change', function (e) {
    var t = e && e.target;
    if (uploadReqShown && t && t.classList &&
        (t.classList.contains('px-upinput') || t.classList.contains('px-hw-upinput'))) {
      setTimeout(refreshUploadReq, 0);
    }
  });

  /* ------------------------------------------------------------------
     v15.6 — EDIT A CART ITEM ("Bearbeiten" in the cart drawer).

     The drawer link is  /products/<handle>?variant=<id>&px_edit=<line key>.
     editState is set only once the line was found and restored; while it is
     set, a successful add to cart REPLACES that line (pxFinishAdd below).
     No price, no formula, no property name is involved — the restore only
     sets the same inputs a customer would set by hand.
  ------------------------------------------------------------------ */
  var editState = null;   // { key, quantity, addon: { key, quantity, variant_id } | null }
  var $editBanner = null;

  function pxEditKeyFromUrl() {
    try { return new URLSearchParams(location.search).get('px_edit'); } catch (e) { return null; }
  }
  function pxUrlWithoutEdit() {
    try {
      var u = new URL(location.href);
      u.searchParams.delete('px_edit');
      return u.pathname + u.search;
    } catch (e) { return location.pathname; }
  }
  function pxStripEditParam() {
    try {
      if (!pxEditKeyFromUrl()) return;
      history.replaceState(history.state, '', pxUrlWithoutEdit() + location.hash);
    } catch (e) { /* the URL keeps the parameter; harmless */ }
  }
  function pxEndEdit() {
    editState = null;
    if ($editBanner && $editBanner.parentNode) $editBanner.parentNode.removeChild($editBanner);
    $editBanner = null;
    pxStripEditParam();
  }

  // Texts carry data-i18n, so applyLang() also translates them on a
  // client-side language switch.
  function pxShowEditBanner() {
    if ($editBanner) return;
    var el = document.createElement('div');
    el.className = 'px-edit-banner';
    el.setAttribute('role', 'status');
    el.style.cssText = 'margin:0 0 14px;padding:10px 12px;font-size:13px;line-height:1.45;' +
      'color:#14181F;background:#f4f7fb;border:1px solid #d6e0eb;border-left:3px solid #E30613;';
    var txt = document.createElement('div');
    txt.setAttribute('data-i18n', 'editBanner');
    txt.textContent = L.editBanner;
    var files = document.createElement('div');
    files.className = 'px-edit-files';
    var cancel = document.createElement('a');
    cancel.href = pxUrlWithoutEdit();
    cancel.setAttribute('data-i18n', 'editCancel');
    cancel.textContent = L.editCancel;
    cancel.style.cssText = 'display:inline-block;margin-top:6px;color:#14181F;text-decoration:underline;';
    el.appendChild(txt);
    el.appendChild(files);
    el.appendChild(cancel);
    root.insertBefore(el, root.firstChild);
    $editBanner = el;
  }
  function pxEditFileFailed(name, url) {
    if (!$editBanner) return;
    var box = $editBanner.querySelector('.px-edit-files');
    if (!box) return;
    var row = document.createElement('div');
    row.style.cssText = 'margin-top:6px;color:#b3261e;';
    var t = document.createElement('span');
    t.setAttribute('data-i18n', 'editFileFailed');
    t.textContent = L.editFileFailed;
    var a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = name;
    a.style.cssText = 'margin-left:4px;color:#b3261e;text-decoration:underline;word-break:break-all;';
    row.appendChild(t);
    row.appendChild(a);
    box.appendChild(row);
  }

  function pxEditCfg(props) {
    try { return props && props._cfg ? JSON.parse(props._cfg) : null; } catch (e) { return null; }
  }
  // A B2B offer replayed into the cart carries the AGREED price in
  // _calculated_price, while _cfg still holds the configurator's own price.
  // Editing such a line would re-price it, so it is not offered.
  function pxIsNegotiated(props, cfg) {
    if (!cfg || props._calculated_price === undefined || props._calculated_price === null) return false;
    var cp = String(props._calculated_price);
    return cp !== String(cfg.net) && cp !== String(cfg.gross);
  }
  function pxParseDim(v) {
    if (v === null || v === undefined || v === '') return NaN;
    var n = parseFloat(String(v).replace(',', '.'));
    return isFinite(n) ? round1(n) : NaN;
  }
  // "Indoor Premium für Licht (615022)" -> "615022"
  function pxArticleFromTitle(v) {
    var m = /\(([^()]+)\)\s*$/.exec(String(v || ''));
    return m ? m[1].trim() : null;
  }
  function pxModeFromText(t) {
    t = String(t || '').toLowerCase();
    if (/katalog|catalog/.test(t)) return 'catalog';
    if (/unbedruckt|unprinted/.test(t)) return 'unprinted';
    return 'upload';
  }
  // Selects an ENABLED option by value; fires 'change' only when it moved.
  function pxSetSelect(sel, value) {
    if (!sel || value === null || value === undefined || value === '') return false;
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      if (o.value === String(value) && !o.disabled) {
        if (sel.selectedIndex !== i) {
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }
    return false;
  }
  function pxSetSelectByName(sel, name) {
    if (!sel || !name) return false;
    for (var i = 0; i < sel.options.length; i++) {
      if ((sel.options[i].dataset.name || sel.options[i].text) === name) {
        return pxSetSelect(sel, sel.options[i].value);
      }
    }
    return false;
  }

  function pxEditRestoreAddon(ad) {
    if (!$addons || !ad) return;
    var vid = String(ad.variant_id);
    var box = null;
    $addons.querySelectorAll('.addon-product-checkbox').forEach(function (b) {
      if (!box && String(b.dataset.variantId) === vid) box = b;
    });
    if (box) {
      if (!box.checked) { box.checked = true; box.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    // A variant of an add-on: its own change handler ticks the add-on.
    $addons.querySelectorAll('.px-addon-variant').forEach(function (sel) {
      if (box) return;
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === vid) {
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          box = sel;
          return;
        }
      }
    });
  }

  // Loads every uploaded file of the line back into its own upload field.
  // The field is found by its name: input name="properties[Upload 1]" <->
  // cart property "Upload 1".
  function pxEditRestoreFiles(props) {
    root.querySelectorAll('input[type="file"]').forEach(function (inp) {
      if (inp.getAttribute('data-pxg-motif')) return;          // catalogue cut-out: rebuilt by the gallery
      var m = /^properties\[(.+)\]$/.exec(inp.name || '');
      if (!m) return;
      var url = props[m[1]];
      if (!url || typeof url !== 'string') return;
      if (url.indexOf('//') === 0) url = 'https:' + url;
      if (!/^https?:\/\//i.test(url)) return;
      // Messesystem card not set to "Eigene Datei": its file is not wanted.
      if (inp.classList.contains('px-hw-upinput') && inp.dataset.slot &&
          (parseInt(inp.dataset.slot, 10) > hwCount || hwSlotMode(parseInt(inp.dataset.slot, 10)) !== 'upload')) return;
      var name = 'datei';
      try { name = decodeURIComponent(url.split('?')[0].split('/').pop()) || name; } catch (e) {}
      fetch(url, { mode: 'cors', credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.blob(); })
        .then(function (blob) {
          if (inp.files && inp.files.length) return;   // the customer already chose a new file
          var file = new File([blob], name, { type: blob.type || '', lastModified: Date.now() });
          var dt = new DataTransfer();
          dt.items.add(file);
          inp.files = dt.files;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        })
        .catch(function (err) {
          console.warn('PX: the previous file could not be loaded again', url, err);
          pxEditFileFailed(name, url);
        });
    });
  }

  function pxEditApply(item) {
    var props = item.properties || {};
    var cfg = pxEditCfg(props) || {};

    // 1. quantity — every [name="quantity"], like the Smart Checkout does.
    var q = parseInt(item.quantity, 10) || 1;
    document.querySelectorAll('[name="quantity"]').forEach(function (inp) {
      if (String(inp.value) !== String(q)) {
        inp.value = q;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // 2. dimensions (one decimal), from _cfg, else from the visible property.
    [[$w, cfg.b, PKEY.pW], [$h, cfg.h, PKEY.pH], [$t, cfg.t, PKEY.pT]].forEach(function (d) {
      if (!d[0]) return;
      var n = pxParseDim(d[1]);
      if (!isFinite(n)) n = pxParseDim(props[d[2]]);
      if (isFinite(n) && n > 0) d[0].value = fmtDimDisplay(n);
    });

    // 3. Steuerung (dimming) — through the visible buttons when they exist.
    if ($dim && CFG.formula && CFG.formula.dimmingAvailable && $dim.checked !== !!cfg.dim) {
      var stBtn = document.querySelector('[data-px-steuerung="' + (cfg.dim ? 'mit' : 'ohne') + '"]');
      if (stBtn) stBtn.click();
      else { $dim.checked = !!cfg.dim; $dim.dispatchEvent(new Event('change', { bubbles: true })); }
    }

    // 4. Ausführung (formula products; the Handelsware block is step 9).
    // v15.9: round products (FIXED_MC) never store an Ausführung — their _cfg
    // has exec: null and a diameter (dia). For them a fabric in the line
    // means "Mit Stoffbanner", no fabric means "Ohne Stoffbanner". Restore
    // only: _cfg itself, the price and every property stay exactly as before.
    var execWanted = cfg.exec;
    if (!execWanted && cfg.dia && !$hwWrap && root.querySelector('.px-exec-btn[data-mode="WITH"]')) {
      execWanted = (cfg.fab || props[PKEY.pFab]) ? PKEY.withT : PKEY.withoutT;
    }
    if (execWanted) {
      var wantExec = null;
      root.querySelectorAll('.px-exec-btn[data-mode]').forEach(function (b) {
        if (wantExec || b.closest('#px-hw-modes')) return;
        var m = b.dataset.mode;
        if (m === 'NONE') { if (execWanted === PKEY.withoutT) wantExec = b; return; }
        if (m === 'WITH') { if (execWanted === PKEY.withT) wantExec = b; return; }
        if ([b.dataset.label, b.dataset.pxOriginalExecLabel].some(function (l) {
          return l && l.trim() === execWanted;
        })) wantExec = b;
      });
      if (wantExec && !wantExec.classList.contains('px-active')) wantExec.click();
    }

    // 5. frame colour + RAL code
    if (cfg.col) {
      var colR = root.querySelector('input[name="px-fcolor"][value="' + CSS.escape(String(cfg.col)) + '"]');
      if (colR && !colR.checked) {
        colR.checked = true;
        colR.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    if ($ralCode && cfg.ral && cfg.ral !== 'RAL') $ralCode.value = cfg.ral;

    // 6. price once, so the fabric list reflects the restored size.
    compute();

    // 7. fabric(s)
    pxSetSelect($fabricSelect, cfg.fab || pxArticleFromTitle(props[PKEY.pFab]) || pxArticleFromTitle(props[PKEY.pFabF]));
    pxSetSelect($fabricSelect2, cfg.fab2 || pxArticleFromTitle(props[PKEY.pFabB]));

    // 8. print data + cable output
    pxSetSelect($pdSelect, cfg.pd);
    pxSetSelect($cableSelect, cfg.cab);

    // 9. Handelsware / Messesystem: textile count, fabric and artwork per card.
    var hw = null;
    if ($hwWrap) {
      var n = parseInt(cfg.hwT, 10) || 0;
      Array.prototype.forEach.call($hwModeBtns, function (b) {
        if ((parseInt(b.dataset.count, 10) || 0) === n && !b.classList.contains('px-active')) b.click();
      });
      hw = [];
      for (var i = 1; i <= n; i++) {
        var fabVal = null;
        Object.keys(props).forEach(function (k) { if (!fabVal && k.indexOf(i + ':') === 0) fabVal = props[k]; });
        pxSetSelect($hwWrap.querySelector('.px-hw-fabric[data-slot="' + i + '"]'), pxArticleFromTitle(fabVal));
        hw.push({
          slot: i,
          mode: pxModeFromText(props[hwDesignPropName('de', i)] || props[hwDesignPropName('en', i)]),
          motif: props[hwMotifPropName('de', i)] || props[hwMotifPropName('en', i)] || ''
        });
      }
      pxSetSelectByName($hwPdSelect, props[PKEY.pPd]);
    }

    // 10. add-on ("Dazu passend")
    pxEditRestoreAddon(editState && editState.addon);

    // 11. artwork choice — owned by primex-textile-cards.js (per card / side).
    // v15.11: catalogue motifs without a code (the live catalogues have none)
    // are found by their NAME, which the line carries as "Bildmotiv" (or per
    // side for dualFabric). A line with a motif name is a catalogue line even
    // when _cfg.dsg is empty.
    var detail = { cfg: cfg, props: props, hw: hw, dual: null, single: null };
    if (!$hwWrap) {
      if (CFG.formula && CFG.formula.dualFabric) {
        detail.dual = {
          front: { mode: cfg.modeF || 'upload', code: cfg.dsgF || '',
                   name: props[hwMotifPropName('de', 1)] || props[hwMotifPropName('en', 1)] || '' },
          back: { mode: cfg.modeB || 'upload', code: cfg.dsgB || '',
                  name: props[hwMotifPropName('de', 2)] || props[hwMotifPropName('en', 2)] || '' }
        };
      } else {
        var dsgName = props[PKEY.pDsg] || props[DICT.en.pDsg] || '';
        detail.single = {
          mode: cfg.prt === 'NO' ? 'unprinted' : ((cfg.dsg || dsgName) ? 'catalog' : 'upload'),
          code: cfg.dsg || '',
          name: dsgName
        };
      }
    }
    try {
      root.dispatchEvent(new CustomEvent('px:edit-restore', { bubbles: true, detail: detail }));
    } catch (e) { /* very old browsers: core fields are still restored */ }
    // No card UI on this product: set the print choice directly.
    if (detail.single && cfg.prt && !root.querySelector('.px-hwc-mode-btn')) {
      var pb = root.querySelector('.px-print-btn[data-print="' + cfg.prt + '"]');
      if (pb && !pb.classList.contains('px-active')) pb.click();
    }
    compute();

    // 12. uploaded files (asynchronous)
    pxEditRestoreFiles(props);
  }

  function pxEditStart() {
    var key = pxEditKeyFromUrl();
    if (!key || !form) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var idx = -1;
        for (var i = 0; i < items.length; i++) { if (items[i].key === key) { idx = i; break; } }
        if (idx < 0) { pxStripEditParam(); return; }
        var item = items[idx];
        var props = item.properties || {};
        var cfg = pxEditCfg(props);
        // v15.10: products without a Formula JSON (FIXED_MC, Handelsware) take
        // articleNo from the SKU of the variant the page was rendered with, so
        // a size picked on the page (no reload) gives the line another SKU than
        // the edit page. Such a line is recognised by its variant: a variant id
        // listed in this page's variantTitles belongs to this product.
        var sameProduct = !cfg || !cfg.a || !CFG.articleNo || String(cfg.a) === String(CFG.articleNo) ||
          !!(CFG.variantTitles && Object.prototype.hasOwnProperty.call(CFG.variantTitles, String(item.variant_id)));
        if (!cfg || !sameProduct || pxIsNegotiated(props, cfg)) {
          pxStripEditParam();
          return;
        }
        // Its add-on line ("Zubehör für" = this article): the neighbour line
        // first, because both were added together. v15.10: also the article
        // number stored in the line itself (see above).
        var lineArticle = cfg.a ? String(cfg.a) : null;
        function isAddonFor(it) {
          var p = (it && it.properties) || {};
          var v = p[PKEY.pAddonFor] || p[DICT.en.pAddonFor];
          return !!v && (v === CFG.articleNo || (lineArticle !== null && v === lineArticle));
        }
        var addon = null;
        if (isAddonFor(items[idx - 1])) addon = items[idx - 1];
        else if (isAddonFor(items[idx + 1])) addon = items[idx + 1];
        else for (var j = 0; j < items.length; j++) { if (isAddonFor(items[j])) { addon = items[j]; break; } }
        editState = {
          key: item.key,
          quantity: item.quantity,
          addon: addon ? { key: addon.key, quantity: addon.quantity, variant_id: addon.variant_id } : null
        };
        pxShowEditBanner();
        pxEditApply(item);
      })
      .catch(function (err) { console.warn('PX: edit mode could not read the cart', err); });
  }

  // Called after every successful add from this file. Without edit mode it is
  // exactly the previous behaviour.
  function pxFinishAdd(mainData, addonData, mainQty, addonQty) {
    if (!editState) { pxOpenCartOrReload(addonData || mainData); return; }
    var st = editState;
    pxEndEdit();
    var updates = {};
    // Identical configuration: Shopify merged the new line INTO the old one.
    updates[st.key] = (mainData && mainData.key === st.key) ? mainQty : 0;
    if (st.addon) {
      // The old add-on line may also serve another line of this product, so
      // only this item's share is taken off it.
      var rest = Math.max(0, st.addon.quantity - st.quantity);
      var addOk = (addonData && !addonData.status) ? addonData : null;
      updates[st.addon.key] = (addOk && addOk.key === st.addon.key) ? rest + addonQty : rest;
    }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: pxSectionsToRequest(),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || cart.status) throw cart;
        pxOpenCartOrReload(cart);
      })
      .catch(function (err) {
        console.error('PX: the edited item was added, but the old one could not be removed', err);
        pxOpenCartOrReload(addonData || mainData);
      });
  }

  // Starts after every deferred script (card UI, Smart Checkout, gallery) has
  // built its controls, so the restore drives the finished page.
  function pxWhenUiReady(cb) {
    var tries = 0;
    (function wait() {
      var needCards = !!($textileSection || $hwWrap);
      var ready = !needCards || root.querySelector('.px-hwc-mode-panel, .pxhw-shell, .px-tc-card');
      if (ready || tries++ > 40) { setTimeout(cb, 0); return; }
      setTimeout(wait, 75);
    })();
  }


    window.PXP_restoreConfig = function (item, opts) {
    opts = opts || {};
    if (!item || !form) return false;
    if (editState) return false;              // a cart edit is running: never mix the two
    pxWhenUiReady(function () {
      try {
        pxEditApply(item);
        if (opts.addon) pxEditRestoreAddon(opts.addon);
      } catch (e) {
        console.warn('PX: offer restore failed', e);
      }
      if (typeof opts.done === 'function') setTimeout(opts.done, 0);
    });
    return true;
  };
  // ---------- add-to-cart submit ----------
  // No files: normal theme flow. Files: FormData takeover (theme AJAX drops file
  // inputs), then the drawer ALWAYS opens: renderContents, else reload + auto-open.
  if (form) form.addEventListener('submit', function (e) {
    clearTimeout(deb);
    compute();
    var priced = form.querySelector('input[name="properties[_calculated_price]"]');
    if (!priced || !priced.value) { e.preventDefault(); e.stopPropagation(); return; }

    // v15.4: "Eigene Datei" without a file. Checked before the add-on rule
    // because the upload area sits higher on the page.
    var missing = missingUploads();
    if (missing.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      flagUploadMissing(missing);
      if (submitBtn) { submitBtn.removeAttribute('aria-busy'); submitBtn.disabled = false; }
      return;
    }

    // v15.2: mandatory add-on. Blocked here rather than by disabling the
    // button, so that the Smart Checkout buttons — which work by clicking the
    // real submit button — also land on a visible reason instead of silently
    // doing nothing against a disabled control.
    if (!addonOk()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      flagAddonMissing();
      if (submitBtn) { submitBtn.removeAttribute('aria-busy'); submitBtn.disabled = false; }
      return;
    }

    var addonSel = addonSelection();
    // v15.6: in edit mode this file always adds the line itself, because the
    // old line may only be removed after an add that succeeded.
    if (!anyFiles() && !addonSel && !editState) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var fd = new FormData(form);
    root.querySelectorAll('.px-upinput').forEach(function (inp) {
      if (inp.files && inp.files.length && !fd.has(inp.name)) fd.append(inp.name, inp.files[0]);
    });
    if (editState) {
      // v15.6: the theme's own add-to-cart is skipped in edit mode, so the
      // Messesystem card uploads must be carried here as well.
      root.querySelectorAll('.px-hw-upinput').forEach(function (inp) {
        if (inp.name && inp.files && inp.files.length && !fd.has(inp.name)) fd.append(inp.name, inp.files[0]);
      });
    }
    var mainQty = getQty();
    fd.append('sections', pxSectionsToRequest());
    fd.append('sections_url', window.location.pathname);

    if (submitBtn) { submitBtn.setAttribute('aria-busy', 'true'); submitBtn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          console.error('PX add error', data);
          alert(data.description || data.message || L.addError);
          return;
        }
        if (addonSel) {
          // second line: the add-on, factor-priced via _calculated_price
          var q2 = getQty();
          var adNet = addonUnitNetCents(q2);
          var adGross = Math.round(adNet * (1 + CFG.settings.vat));
          var props = {};
          // v15.0: cart property name is ALWAYS German — see PKEY at the top.
          props[PKEY.pAddonFor] = CFG.articleNo;
          props['_calculated_price'] = String(CFG.settings.taxesIncluded ? adGross : adNet);
          // v14.41: props is untouched — the add-on line still carries exactly
          // the same _calculated_price the Cart Transform function expects. The
          // only change is asking for the drawer sections so this second add
          // can be rendered instead of forcing a reload.
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: addonSel.variantId,
              quantity: q2,
              properties: props,
              sections: pxSectionsToRequest(),
              sections_url: window.location.pathname
            })
          })
            .then(function (r) { return r.json(); })
            .then(function (addonData) { pxFinishAdd(data, addonData, mainQty, q2); })
            .catch(function (err) {
              console.error('PX addon add failed', err);
              pxFinishAdd(data, null, mainQty, q2);
            });
          return;
        }
        // v14.41: was a single hardcoded <cart-drawer> + renderContents check
        // that fell back to window.location.reload(). pxOpenCartOrReload() tries
        // five routes and only reloads if every one of them fails.
        pxFinishAdd(data, null, mainQty, 0);
      })
      .catch(function (err) {
        console.error('PX add failed', err);
        try { sessionStorage.setItem('px-open-drawer', '1'); } catch (e2) {}
        window.location.reload();
      })
      .finally(function () {
        if (submitBtn) { submitBtn.removeAttribute('aria-busy'); submitBtn.disabled = false; }
      });
  }, true);

  // If the last add-to-cart still had to fall back to a reload, open the drawer
  // now. v14.41: the old version looked for the element ONCE at parse time and
  // deleted the flag whether or not it found one — so when the drawer element
  // was defined by a deferred theme script, nothing opened and the flag was
  // already gone. That is why the cart stayed closed after the reload. Retry for
  // three seconds and keep the flag until it actually works.
  try {
    if (sessionStorage.getItem('px-open-drawer') === '1') {
      var pxTries = 0;
      var pxTimer = setInterval(function () {
        pxTries++;
        if (pxForceOpen(pxCartDrawerEl()) || pxTries >= 12) {
          clearInterval(pxTimer);
          try { sessionStorage.removeItem('px-open-drawer'); } catch (e2) {}
        }
      }, 250);
    }
  } catch (e) {}

  setSubmitEnabled(false);
  applyLang();

  // v15.6: "Bearbeiten" from the cart.
  if (pxEditKeyFromUrl()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { pxWhenUiReady(pxEditStart); });
    } else {
      pxWhenUiReady(pxEditStart);
    }
  }

  /* ---------------------------------------------------------------------
     v15.0: react to a language switch that happens WITHOUT a page reload.

     Weglot can change the storefront language client-side; when it does it
     rewrites <html lang>. Everything below is a pure DISPLAY refresh —
     cart property names and values are frozen German via PKEY, so nothing
     the Cart Transform or the B2B quote module reads is affected.

     Guarded on all sides: a no-op when Weglot is absent.
     --------------------------------------------------------------------- */
  (function pxWatchLanguage() {
    function relang() {
      var next = pxDetectLang();
      if (next === lang) return;
      lang = next;
      window.PX_LANG = lang;
      L = DICT[lang];
      applyLang();   // re-reads DICT[lang], rebuilds every [data-i18n], calls compute()
      try {
        document.dispatchEvent(new CustomEvent('px:lang-change', { detail: { lang: lang } }));
      } catch (e) {}
    }
    try {
      if (window.Weglot && typeof window.Weglot.on === 'function') {
        window.Weglot.on('languageChanged', relang);
      }
    } catch (e) { /* Weglot absent — the observer below still covers it */ }
    if (window.MutationObserver) {
      new MutationObserver(relang).observe(document.documentElement, {
        attributes: true, attributeFilter: ['lang']
      });
    }
  })();
})();


 